

<template>
  <!-- <img alt="Vue logo" src="./assets/logo.png" />
    <HelloWorld msg="Welcome to Your Vue.js App"/> 
  -->
  <!-- inicio de menu -->

  <!-- fin de menu -->
  <div class="container-fluid">
    <div class="card bg-white">
      <!-- inicio de menu promociones -->

      <!-- fin ver listado promociones -->
      <!-- ver listado editar promociones -->
      <template v-if="listar == 51">
        <!--
        <div class="card-body">    
          <div class="form-group row">
            <div class="card">
              <div class="card-header">
                Featured
              </div>
              <div class="card-body">
                <h5 class="card-title">Special title treatment</h5>
                <p class="card-text">With supporting text below as a natural lead-in to additional content.</p>
              </div>
            </div>
         </div>  
        </div>
        -->

        <div class="">
          <div class="row">
            <!--incio de buscador-->
            <div class="col-md-12">
              <h6 class="fw-bold">Movimientos de Clientes</h6>
            </div>
            <hr />
            <div class="col-md-12">
              <div class="col-md-10">
                <div class="input-group">
                  <span
                    class="input-group-text"
                    id="basic-addon1"
                    style="font-size: 12px"
                    >Id&nbsp;de&nbsp;cliente:</span
                  >
                  <input
                    type="text"
                    v-model="buscar"
                    placeholder="Código de cliente/CI/RUC"
                    style="font-size: 12px; width: 170px"
                    @keyup.enter="listarPromocionesCliente(buscar)"
                    size="30"
                  />
                  <span
                    class="input-group-text"
                    id="basic-addon1"
                    style="font-size: 12px; width: 60%"
                    >{{ descripcionCliente }}</span
                  >
                </div>
              </div>
            </div>

            <div class="col-md-2"></div>

            <div><hr /></div>

            <!-- fin de buscador -->
            <!-- inicio de la tabla -->
            <div class="container" style="font-size: 12px">
              <div class="card">
                <div class="accordion" id="accordionExample">
                  <div class="accordion-item">
                    <h1 class="accordion-header" id="headingOne">
                      <button
                        class="accordion-button btn btn-sm fw-bold"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                        style="
                          background: #ebeef6;
                          font-size: 12px;
                          height: 8px;
                          color: #000000;
                        "
                      >
                        Acumulaciones activas - Cliente
                      </button>
                    </h1>
                    <div
                      id="collapseOne"
                      class="accordion-collapse collapse show"
                      aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample"
                    >
                      <div
                        class="row"
                        style="
                          font-size: 11px;
                          min-height: 100px;
                          max-height: 430px;
                        "
                      >
                        <div class="col-md-6">
                          <!--listar promos con filtro codigo producto-->
                          <div class="col-md-9">
                            <div>
                              <div style="font-size: 12px" class="text-start">
                                <label class="fw-bold"
                                  >&nbsp;&nbsp;Buscar&nbsp;producto:</label
                                >
                                <!--&nbsp;Código&nbsp;
                                <label class="switch">
                                  <input
                                    type="checkbox"
                                    v-model="selectCodDes"
                                    true-value="1"
                                    false-value="0"
                                  />
                                  <span class="slider round"></span> </label
                                >&nbsp;Nombre
                                -->
                              </div>
                            </div>
                            <div class="input-group" style="font-size: 12px">
                              <label class="fw-bold">&nbsp;</label>
                              <input
                                v-if="selectCodDes == 0"
                                type="text"
                                v-model="buscarPromoProductoLk"
                                class="form-control-sm form-control col-md-3"
                                placeholder="Código o nombre de producto"
                                style="font-size: 12px"
                                @keyup.enter="buscarPromoProducto()"
                              />
                              <input
                                v-else
                                type="text"
                                v-model="buscarPromoProductoLk"
                                class="form-control-sm form-control col-md-3"
                                placeholder="Nombre de producto"
                                style="font-size: 12px"
                                @keyup.enter="buscarPromoProducto()"
                              />
                            </div>
                          </div>

                          <br />

                          <div
                            class="table-responsive"
                            style="
                              overflow-y: scroll;
                              font-size: 11px;
                              min-height: 50px;
                              max-height: 250px;
                            "
                          >
                            <table
                              class="table table-hover table-bordered table-sm col-md-12"
                              style="overflow-y: scroll"
                            >
                              <thead>
                                <tr class="tab-cabecere">
                                  <th>Código Promoción<br /></th>

                                  <th width="30%">Nombre<br /></th>
                                  <th>Modalidad<br /></th>
                                  <th>Fecha<br />Inicio<br /></th>
                                  <th>Fecha<br />Fin<br /></th>
                                  <th>Estado<br /></th>

                                  <!--
                        <th>Proveedor</th>
                        <th>Laboratorio</th>
                        -->
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(
                                    promocion, index
                                  ) in arrayPromocionesAll"
                                  :key="index"
                                >
                                  <td
                                    v-if="
                                      status_select == promocion.codigoPromocion
                                    "
                                    style="
                                      font-size: 11px;
                                      text-align: center;
                                      background-color: #139ab8;
                                      width: 9%;
                                      color: #ffffff;
                                    "
                                    v-text="promocion.codigoPromocion"
                                    @click="
                                      verPromocion(promocion.codigoPromocion, 0)
                                    "
                                  ></td>
                                  <td
                                    v-else
                                    style="font-size: 11px"
                                    v-text="promocion.codigoPromocion"
                                    @click="
                                      verPromocion(promocion.codigoPromocion, 0)
                                    "
                                  ></td>
                                  <td
                                    v-if="
                                      status_select == promocion.codigoPromocion
                                    "
                                    style="
                                      font-size: 11px;
                                      text-align: left;
                                      background-color: #139ab8;
                                      color: #ffffff;
                                    "
                                    v-text="promocion.nombre"
                                    @click="
                                      verPromocion(promocion.codigoPromocion, 0)
                                    "
                                  ></td>
                                  <td
                                    v-else
                                    style="font-size: 11px; text-align: left"
                                    v-text="promocion.nombre"
                                    @click="
                                      verPromocion(promocion.codigoPromocion, 0)
                                    "
                                  ></td>
                                  <td
                                    v-if="
                                      status_select == promocion.codigoPromocion
                                    "
                                    style="
                                      font-size: 11px;
                                      text-align: center;
                                      background-color: #139ab8;
                                      color: #ffffff;
                                    "
                                    v-text="promocion.tipoMF"
                                    @click="
                                      verPromocion(promocion.codigoPromocion, 0)
                                    "
                                  ></td>
                                  <td
                                    v-else
                                    style="font-size: 11px"
                                    v-text="promocion.tipoMF"
                                    @click="
                                      verPromocion(promocion.codigoPromocion, 0)
                                    "
                                  ></td>
                                  <td
                                    v-if="
                                      status_select == promocion.codigoPromocion
                                    "
                                    style="
                                      font-size: 11px;
                                      text-align: center;
                                      background-color: #139ab8;
                                      color: #ffffff;
                                    "
                                    v-text="promocion.fechaInicio"
                                    @click="
                                      verPromocion(promocion.codigoPromocion, 0)
                                    "
                                  ></td>
                                  <td
                                    v-else
                                    style="font-size: 11px"
                                    v-text="promocion.fechaInicio"
                                    @click="
                                      verPromocion(promocion.codigoPromocion, 0)
                                    "
                                  ></td>
                                  <td
                                    v-if="
                                      status_select == promocion.codigoPromocion
                                    "
                                    style="
                                      font-size: 11px;
                                      text-align: center;
                                      background-color: #139ab8;
                                      color: #ffffff;
                                    "
                                    v-text="promocion.fechaFin"
                                    @click="
                                      verPromocion(promocion.codigoPromocion, 0)
                                    "
                                  ></td>
                                  <td
                                    v-else
                                    style="font-size: 11px"
                                    v-text="promocion.fechaFin"
                                    @click="
                                      verPromocion(promocion.codigoPromocion, 0)
                                    "
                                  ></td>
                                  <td
                                    v-if="
                                      status_select == promocion.codigoPromocion
                                    "
                                    style="
                                      font-size: 11px;
                                      text-align: center;
                                      background-color: #139ab8;
                                      color: #ffffff;
                                    "
                                    v-text="promocion.estado"
                                    @click="
                                      verPromocion(promocion.codigoPromocion, 0)
                                    "
                                  ></td>
                                  <td
                                    v-else
                                    style="font-size: 11px"
                                    v-text="promocion.estado"
                                    @click="
                                      verPromocion(promocion.codigoPromocion, 0)
                                    "
                                  ></td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <!--fin listar promos con filtro cliente-->
                        </div>
                        <div class="col-md-6">
                          <h6
                            v-if="codigoPromocion != ''"
                            class="fw-bold"
                            style="font-size: 12px"
                          >
                            Datos de la promoción
                          </h6>
                          <br />
                          <div
                            class="table-responsive"
                            style="
                              overflow-y: scroll;
                              font-size: 11px;
                              min-height: 50px;
                              max-height: 315px;
                            "
                          >
                            <table
                              v-if="codigoPromocion"
                              style="text-align: left; font-size: 11px"
                              cellpadding="0"
                              cellspacing="0"
                              class="table table-sm"
                            >
                              <tbody>
                                <tr class="align-middle">
                                  <th
                                    class="text-end"
                                    scope="row"
                                    style="width: 20rem; font-size: 12px"
                                  >
                                    Código:&nbsp;
                                  </th>
                                  <td
                                    style="width: 35px; font-size: 12px"
                                    v-text="codigoPromocion"
                                  ></td>
                                  <th
                                    class="text-end"
                                    scope="row"
                                    style="width: 50px"
                                  ></th>
                                  <td style="width: 15rem"></td>
                                  <td
                                    style="
                                      font-size: 8;
                                      width: 15rem;
                                      vertical-align: center;
                                    "
                                  >
                                    <div
                                      style="
                                        font-size: 8;
                                        border: 2px;
                                        border-style: ridge;
                                        background: #139ab8;
                                        color: #ffffff;
                                        height: 25px;
                                      "
                                      @click="
                                        verPromocionTodoTodo(codigoPromocion, 1)
                                      "
                                    >
                                      &nbsp;&nbsp;<i class="fas fa-cogs"></i
                                      >&nbsp;&nbsp;Ver&nbsp;configuración&nbsp;
                                    </div>
                                  </td>
                                </tr>
                                <tr style="background-color: #ebeef6">
                                  <th
                                    class="text-end"
                                    scope="row"
                                    style="width: 20rem; font-size: 12px"
                                  >
                                    Total canjes&nbsp;cliente:&nbsp;
                                  </th>
                                  <th
                                    class="text-start"
                                    v-text="nroCanjes"
                                    style="font-size: 13px"
                                  ></th>
                                  <th
                                    class="text-end"
                                    scope="row"
                                    style="width: 35px; font-size: 12px"
                                    colspan="2"
                                  >
                                    Total&nbsp;canjes&nbsp;acumulación:
                                  </th>
                                  <th
                                    class="text-start"
                                    scope="row"
                                    style="width: 50px; font-size: 13px"
                                    v-text="nroTCanjes"
                                  ></th>
                                </tr>
                                <tr>
                                  <th class="text-end" scope="row">
                                    Descripción:
                                  </th>
                                  <td colspan="4">
                                    <p>{{ observacionesPromocion }}</p>
                                  </td>
                                </tr>

                                <tr>
                                  <th
                                    class="text-end CellWithComment"
                                    scope="row"
                                  >
                                    Descripción&nbsp;mecánica:&nbsp;<i
                                      class="fas fa-question-circle"
                                    ></i>
                                    <!--Tool tip de mensajes-->
                                    <div
                                      class="card text-start CellComment"
                                      id="span1"
                                    >
                                      <div
                                        class="card-header"
                                        style="top: -15px"
                                      >
                                        Descripción&nbsp;mecánica
                                      </div>
                                      <div
                                        class="men-tooltip card-body text-start lh-sm"
                                        style="
                                          top: -5px;
                                          min-height: 25px;
                                          max-height: 150px;
                                        "
                                      >
                                        <!--<p style="text-align: justify">-->
                                        Indica la relación que existe entre la
                                        acumulación y la cantidad de producto a
                                        recibir como beneficio.
                                      </div>
                                    </div>
                                    <!--Tool tip de mensajes-->
                                  </th>
                                  <td
                                    v-text="mecanica"
                                    style="width: 15rem"
                                    colspan="4"
                                  ></td>
                                </tr>
                                <tr>
                                  <th
                                    class="text-end CellWithComment"
                                    scope="row"
                                    style="width: 15rem"
                                  >
                                    Modalidad:&nbsp;<i
                                      class="fas fa-question-circle"
                                    ></i>
                                    <div
                                      class="card text-start CellComment"
                                      id="span1"
                                    >
                                      <div
                                        class="card-header"
                                        style="top: -15px"
                                      >
                                        Modalidad
                                      </div>
                                      <div
                                        class="men-tooltip card-body text-start lh-sm"
                                        style="
                                          top: -5px;
                                          min-height: 25px;
                                          max-height: 150px;
                                        "
                                      >
                                        Tipo de clasificación de la promoción.
                                      </div>
                                    </div>
                                  </th>
                                  <td v-text="tipoMF" style="" colspan="4"></td>
                                </tr>

                                <tr>
                                  <th
                                    class="text-end CellWithComment"
                                    scope="row"
                                  >
                                    Inicio de&nbsp;acumulación:&nbsp;<i
                                      class="fas fa-question-circle"
                                    ></i>
                                    <div
                                      class="card text-start CellComment"
                                      id="span1"
                                    >
                                      <div
                                        class="card-header"
                                        style="top: -15px"
                                      >
                                        Inicio de acumulación
                                      </div>
                                      <div
                                        class="men-tooltip card-body text-start lh-sm"
                                        style="
                                          top: -5px;
                                          min-height: 25px;
                                          max-height: 200px;
                                        "
                                      >
                                        Fecha, hora y minutos desde cuando va a
                                        comenzar a tener acumulaciones de
                                        productos según la condición. Esta fecha
                                        se controla con la configuración de
                                        “Pendiente canje”.
                                      </div>
                                    </div>
                                  </th>
                                  <td
                                    style="width: 10rem"
                                    v-text="fechaInicioAcumulacion"
                                    colspan="4"
                                  ></td>
                                </tr>
                                <tr>
                                  <th
                                    class="text-end CellWithComment"
                                    scope="row"
                                  >
                                    Período&nbsp;de&nbsp;canje:&nbsp;<i
                                      class="fas fa-question-circle"
                                    ></i>
                                    <div
                                      class="card text-start CellComment"
                                      id="span1"
                                    >
                                      <div
                                        class="card-header"
                                        style="top: -15px"
                                      >
                                        Período de canje
                                      </div>
                                      <div
                                        class="men-tooltip card-body text-start lh-sm"
                                        style="
                                          top: -5px;
                                          min-height: 25px;
                                          max-height: 150px;
                                        "
                                      >
                                        Número de meses con los cuales la
                                        promoción se puede reiniciar los limites
                                        de aplicación de la promoción.
                                      </div>
                                    </div>
                                  </th>
                                  <td colspan="4">
                                    {{ periodoCanje }}&nbsp;{{
                                      unidadPeriodoCanje
                                    }}
                                  </td>
                                </tr>
                                <tr>
                                  <th
                                    class="text-end CellWithComment"
                                    scope="row"
                                    style="width: 10rem"
                                    v-if="tipoMF != 'Tratamiento Completo'"
                                  >
                                    Pendiente&nbsp;canje:&nbsp;<i
                                      class="fas fa-question-circle"
                                    ></i>
                                    <div
                                      class="card text-start CellComment"
                                      id="span1"
                                    >
                                      <div
                                        class="card-header"
                                        style="top: -15px"
                                      >
                                        Pendiente canje
                                      </div>
                                      <div
                                        class="men-tooltip card-body text-start lh-sm"
                                        style="
                                          top: -5px;
                                          min-height: 25px;
                                          max-height: 150px;
                                        "
                                      >
                                        Número de meses a partir de la fecha
                                        actual hacia atrás para poder considerar
                                        las unidades acumuladas y poder
                                        determinar si aplica la entrega del
                                        beneficio.
                                      </div>
                                    </div>
                                  </th>
                                  <td
                                    v-if="tipoMF != 'Tratamiento Completo'"
                                    colspan="4"
                                  >
                                    {{ mesPendienteCanje }}&nbsp;{{
                                      unidadPeriodoCanje
                                    }}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- fin de la tabla-->
            <!--condiciones-->
            <div class="container" style="font-size: 12px">
              <div class="card">
                <div class="accordion" id="accordionExample1">
                  <div class="accordion-item">
                    <h1 class="accordion-header" id="headingOne">
                      <button
                        class="accordion-button btn btn-sm fw-bold"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne1"
                        aria-expanded="true"
                        aria-controls="collapseOne1"
                        style="
                          background: #ebeef6;
                          font-size: 12px;
                          height: 8px;
                          color: #000000;
                        "
                      >
                        Datos de acumulaciones
                      </button>
                    </h1>
                    <div
                      id="collapseOne1"
                      class="accordion-collapse collapse show"
                      aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample1"
                    >
                      <div
                        class="accordion-body"
                        style="
                          min-height: 100px;
                          font-size: 11px;
                          max-height: 450px;
                        "
                      >
                        <!--row-->
                        <div class="row" style="height: 10px">
                          <div class="text-end col-md-11"></div>
                          <div class="text-end col-md-1 invisible">
                            <table
                              class="table table-bordered table-striped table-sm text-end"
                              style="font-size: 12px; width: 30px"
                            >
                              <tr>
                                <th class="text-star CellWithComment1">
                                  &nbsp;<i
                                    class="fas fa-question-circle"
                                    style="font-size: 12px"
                                  ></i>
                                  <div
                                    class="card text-start CellComment1"
                                    id="span2"
                                  >
                                    <div class="card-header">Referencia</div>
                                    <div
                                      class="men-tooltip card-body text-start"
                                    >
                                      <p class="card-text">
                                        <i
                                          class="far fa-square"
                                          style="background: #80d1e7"
                                        ></i
                                        >&nbsp;Acumula&nbsp;entre&nbsp;todos.
                                      </p>
                                      <p class="card-text">
                                        <i
                                          class="far fa-square"
                                          style="background: #8fe88a"
                                        ></i
                                        >&nbsp;Acumula&nbsp;de&nbsp;forma&nbsp;individual.
                                      </p>
                                    </div>
                                  </div>
                                </th>
                              </tr>
                            </table>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <!--buscar-->
                            <!--
                            <div class="row">
                              <div class="col-md-12">
                                <div class="input-group" style="font-size: 13px">
                                  <label class="fw-bold"
                                    >Buscar:&nbsp;&nbsp;&nbsp;</label
                                  ><input
                                    type="text"
                                    v-model="buscarCondicionesLk"
                                    class="form-control-sm form-control col-md-2"
                                    placeholder="Buscar condiciones"
                                    style="font-size: 12px"
                                    @keyup.enter="buscarCondicionesLike()"
                                  />
                                </div>
                              </div>
                            </div>
                            <br />
                            -->
                            <!--fin buscar -->
                            <div class="row">
                              <div class="col-md-12">
                                <div
                                  class="table-responsive"
                                  v-for="(
                                    aBen, index
                                  ) in arrayCondicionesProcess"
                                  :key="index"
                                  style="
                                    font-size: 10px;
                                    min-height: 100px;
                                    max-height: 250px;
                                    overflow-y: scroll;
                                    border: 1.5px;
                                    border-style: ridge;
                                  "
                                >
                                  <div class="text-start fw-bold">
                                    <label style="font-size: 12px"
                                      >Condición: {{ index + 1 }}:</label
                                    >
                                  </div>
                                  <table
                                    class="table table-bordered table-striped table-sm tab-head"
                                    style="font-size: 10px"
                                  >
                                    <thead class="table-light">
                                      <tr class="tab-cabecere">
                                        <th>Código</th>
                                        <th>Descripción</th>
                                        <th class="text-end">Valor<br />Pos</th>
                                        <th>Acum.<br />Cajas</th>
                                        <th>Cant.<br />Requerida</th>
                                        <th>Cant.<br />Acumulada</th>
                                      </tr>
                                    </thead>
                                    <tr
                                      v-for="(cond, indexx) in aBen.cod"
                                      :key="indexx"
                                      style="border: 0.5px"
                                    >
                                      <td
                                        v-if="
                                          status_select_cond_doc ==
                                          cond.codigoProducto
                                        "
                                        style="
                                          background-color: #139ab8;
                                          color: #ffffff;
                                        "
                                        class="text-start"
                                        @click="
                                          cargarAcumulacionesAcIn(
                                            index,
                                            cond.codigoProducto,
                                            cond.descripcionProducto
                                          )
                                        "
                                      >
                                        {{ cond.codigoProducto }}
                                      </td>
                                      <td
                                        v-else
                                        class="text-start"
                                        @click="
                                          cargarAcumulacionesAcIn(
                                            index,
                                            cond.codigoProducto,
                                            cond.descripcionProducto
                                          )
                                        "
                                      >
                                        {{ cond.codigoProducto }}
                                      </td>

                                      <td
                                        v-if="
                                          status_select_cond_doc ==
                                          cond.codigoProducto
                                        "
                                        style="
                                          background-color: #139ab8;
                                          color: #ffffff;
                                        "
                                        class="text-start"
                                        @click="
                                          cargarAcumulacionesAcIn(
                                            index,
                                            cond.codigoProducto,
                                            cond.descripcionProducto
                                          )
                                        "
                                      >
                                        {{ cond.descripcionProducto }}
                                      </td>
                                      <td
                                        v-else
                                        class="text-start"
                                        @click="
                                          cargarAcumulacionesAcIn(
                                            index,
                                            cond.codigoProducto,
                                            cond.descripcionProducto
                                          )
                                        "
                                      >
                                        {{ cond.descripcionProducto }}
                                      </td>
                                      <td
                                        v-if="
                                          status_select_cond_doc ==
                                          cond.codigoProducto
                                        "
                                        style="
                                          background-color: #139ab8;
                                          color: #ffffff;
                                        "
                                        @click="
                                          cargarAcumulacionesAcIn(
                                            index,
                                            cond.codigoProducto,
                                            cond.descripcionProducto
                                          )
                                        "
                                      >
                                        {{ cond.valorPos }}
                                      </td>
                                      <td
                                        v-else
                                        @click="
                                          cargarAcumulacionesAcIn(
                                            index,
                                            cond.codigoProducto,
                                            cond.descripcionProducto
                                          )
                                        "
                                      >
                                        {{ cond.valorPos }}
                                      </td>

                                      <td v-if="cond.acumulacionCajas == true">
                                        SI
                                      </td>
                                      <td v-if="cond.acumulacionCajas == false">
                                        NO
                                      </td>

                                      <td
                                        v-if="
                                          status_select_cond_doc ==
                                          cond.codigoProducto
                                        "
                                        style="
                                          background-color: #139ab8;
                                          color: #ffffff;
                                        "
                                        @click="
                                          cargarAcumulacionesAcIn(
                                            index,
                                            cond.codigoProducto,
                                            cond.descripcionProducto
                                          )
                                        "
                                      >
                                        {{ cond.cantidad }}
                                      </td>
                                      <td
                                        v-else
                                        @click="
                                          cargarAcumulacionesAcIn(
                                            index,
                                            cond.codigoProducto,
                                            cond.descripcionProducto
                                          )
                                        "
                                      >
                                        {{ cond.cantidad }}
                                      </td>
                                      <td
                                        v-if="
                                          status_select_cond_doc ==
                                          cond.codigoProducto
                                        "
                                        style="
                                          background-color: #139ab8;
                                          color: #ffffff;
                                        "
                                        @click="
                                          cargarAcumulacionesAcIn(
                                            index,
                                            cond.codigoProducto,
                                            cond.descripcionProducto
                                          )
                                        "
                                      >
                                        {{ cond.cantidadAcumulada }}
                                      </td>
                                      <td
                                        v-else
                                        @click="
                                          cargarAcumulacionesAcIn(
                                            index,
                                            cond.codigoProducto,
                                            cond.descripcionProducto
                                          )
                                        "
                                      >
                                        {{ cond.cantidadAcumulada }}
                                      </td>
                                    </tr>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div v-if="codigoPromocion != ''" class="col-md-6">
                            <div class="col-md-12">
                              <div class="fw-bold text-start">
                                <h6
                                  class="fw-bold text-start"
                                  style="font-size: 12px"
                                >
                                  Producto:&nbsp;<label
                                    style="
                                      background-color: #d4e6f1;
                                      color: #000000;
                                      border: 1px #000;
                                      border-style: ridge;
                                    "
                                    >&nbsp;&nbsp;{{
                                      descripcionProductSelect
                                    }}&nbsp;&nbsp;</label
                                  >
                                </h6>
                              </div>
                              <div class="fw-bold text-start">
                                <h6
                                  class="fw-bold text-start"
                                  style="font-size: 12px"
                                >
                                  Acumulaciones Activas:
                                </h6>
                              </div>
                              <div
                                class="input-group col-md-10"
                                style="font-size: 12px; height: 32px"
                              >
                                <label class="fw-bold"
                                  >Buscar:&nbsp;&nbsp;</label
                                >
                                <input
                                  type="text"
                                  v-model="buscarSerieDocActLk"
                                  class="form-control-sm form-control col-md-3"
                                  placeholder="Serie de documento"
                                  style="font-size: 12px; height: 7px"
                                  @keyup.enter="buscarSerieDocumentoActivo()"
                                />
                              </div>

                              <div
                                class="table-responsive"
                                style="
                                  font-size: 10px;
                                  min-height: 50px;
                                  max-height: 200px;
                                  overflow-y: scroll;
                                  border: 1.5px;
                                  border-style: ridge;
                                "
                              >
                                <table
                                  class="table table-bordered table-striped table-sm tab-head"
                                >
                                  <thead class="table-light">
                                    <tr class="tab-cabecere">
                                      <th class="text-start">Código oficina</th>
                                      <th>Oficina</th>
                                      <th class="text-end">Tipo Doc</th>
                                      <th>Serie</th>
                                      <th>Fecha</th>
                                      <th>Cant.</th>
                                      <th></th>
                                    </tr>
                                  </thead>
                                  <tr
                                    v-for="(
                                      acact, indexx
                                    ) in arrayAcumulacionesAct"
                                    :key="indexx"
                                    style="border: 0.5px"
                                  >
                                    <td class="text-start">
                                      {{ acact.COD_FARMACIA }}
                                    </td>
                                    <td class="text-start">
                                      {{ acact.DES_FARMACIA }}
                                    </td>
                                    <td>{{ acact.TIPO_DOCUMENTO }}</td>
                                    <td>{{ acact.SERIE_DOCUMENTO }}</td>
                                    <td>{{ acact.FECHA_DOCUMENTO }}</td>
                                    <td>{{ acact.CANTIDAD_SALDO }}</td>
                                    <td class="invisible">
                                      {{
                                        (totalTabla =
                                          parseInt(totalTabla) +
                                          parseInt(acact.CANTIDAD_SALDO))
                                      }}
                                    </td>
                                  </tr>
                                  <!-- <tr class="invisible">
                                    <td colspan="5">Total</td>
                                    <td colspan="2" class="text-center">{{totalTabla}}</td>
                                  </tr>
                                  -->
                                </table>
                              </div>
                            </div>
                            <div class="row">.</div>
                            <div class="col-md-12">
                              <div>
                                <h6
                                  class="fw-bold text-start"
                                  style="font-size: 12px"
                                >
                                  Acumulaciones caducadas:
                                </h6>
                              </div>
                              <div
                                class="table-responsive"
                                style="
                                  font-size: 10px;
                                  min-height: 50px;
                                  max-height: 250px;
                                  overflow-y: scroll;
                                  border: 1.5px;
                                  border-style: ridge;
                                "
                              >
                                <table
                                  class="table table-bordered table-sm tab-head"
                                  style="font-size: 10px"
                                >
                                  <thead class="table-light">
                                    <tr class="tab-cabecere">
                                      <th>Código oficina</th>
                                      <th>Oficina</th>
                                      <th class="text-end">Tipo Doc</th>
                                      <th>Serie</th>
                                      <th>Fecha</th>
                                      <th>Cant.</th>
                                    </tr>
                                  </thead>
                                  <tr
                                    v-for="(
                                      acact, indexx
                                    ) in arrayAcumulacionesInact"
                                    :key="indexx"
                                    style="border: 0.5px"
                                  >
                                    <td class="text-start">
                                      {{ acact.COD_FARMACIA }}
                                    </td>
                                    <td class="text-start">
                                      {{ acact.DES_FARMACIA }}
                                    </td>
                                    <td>{{ acact.TIPO_DOCUMENTO }}</td>
                                    <td>{{ acact.SERIE_DOCUMENTO }}</td>
                                    <td>{{ acact.FECHA_DOCUMENTO }}</td>
                                    <td>{{ acact.CANTIDAD_CADUCADOS }}</td>
                                  </tr>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!--fin del row-->
                      </div>
                      <!---->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--fin condiciones-->
            <!--Beneficios canje-->
            <div class="container" style="font-size: 12px">
              <div class="card">
                <div class="accordion" id="accordionExample2">
                  <div class="accordion-item">
                    <h1 class="accordion-header" id="headingOne">
                      <button
                        class="accordion-button btn btn-sm fw-bold"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne2"
                        aria-expanded="true"
                        aria-controls="collapseOne2"
                        style="
                          background: #ebeef6;
                          font-size: 12px;
                          height: 8px;
                          color: #000000;
                        "
                      >
                        Datos de canje
                      </button>
                    </h1>
                    <div
                      id="collapseOne2"
                      class="accordion-collapse collapse show"
                      aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2"
                    >
                      <div
                        class="accordion-body"
                        style="
                          overflow-y: scroll;
                          min-height: 100px;
                          font-size: 11px;
                          max-height: 400px;
                        "
                      >
                        <!--row-->
                        <div class="row">
                          <div class="col-md-6">
                            <!--buscar-->
                            <!--
                          <div class="row invisible">
                            <div class="col-md-12">
                              <div class="input-group" style="font-size: 13px">
                                <label class="fw-bold"
                                  >Buscar:&nbsp;&nbsp;&nbsp;</label
                                ><input
                                  type="text"
                                  v-model="buscarCondicionesLk"
                                  class="form-control-sm form-control col-md-2"
                                  placeholder="Buscar condiciones"
                                  style="font-size: 12px"
                                  @keyup.enter="buscarCondicionesLike()"
                                />
                              </div>
                            </div>
                            
                           
                          </div>
                          -->

                            <!--detalle Datos de canje-->
                            <div class="row">
                              <div class="col-md-12">
                                <div
                                  class="table-responsive"
                                  v-for="(
                                    aCond, index
                                  ) in arrayBeneficiosProcess"
                                  :key="index"
                                  style="
                                    font-size: 10px;
                                    min-height: 50px;
                                    max-height: 150px;
                                    overflow-y: scroll;
                                    border: 1.5px;
                                    border-style: ridge;
                                  "
                                >
                                  <div class="text-start fw-bold">
                                    <label style="font-size: 12px">
                                      Grupo {{ index + 1 }}:</label
                                    >
                                  </div>
                                  <table
                                    class="table table-bordered table-striped table-sm tab-head"
                                    style="font-size: 10px"
                                  >
                                    <thead class="table-light">
                                      <tr class="tab-cabecere">
                                        <th>Código</th>
                                        <th>Descripción</th>
                                        <th>Nro.<br />Canje</th>
                                        <th>Cant.<br />Canje</th>
                                      </tr>
                                    </thead>
                                    <tr
                                      v-for="ben in aCond.beneficios"
                                      style="border: 0.5px"
                                    >
                                      <td
                                        class="text-start"
                                        v-if="
                                          status_select_benef_doc ==
                                          ben.codigoProducto
                                        "
                                        style="
                                          background-color: #139ab8;
                                          color: #ffffff;
                                        "
                                        @click="
                                          cargarCanjesBenef(
                                            index,
                                            ben.codigoProducto
                                          )
                                        "
                                      >
                                        {{ ben.codigoProducto }}
                                      </td>
                                      <td
                                        class="text-start"
                                        v-else
                                        @click="
                                          cargarCanjesBenef(
                                            index,
                                            ben.codigoProducto
                                          )
                                        "
                                      >
                                        {{ ben.codigoProducto }}
                                      </td>

                                      <td
                                        class="text-start"
                                        v-if="
                                          status_select_benef_doc ==
                                          ben.codigoProducto
                                        "
                                        style="
                                          background-color: #139ab8;
                                          color: #ffffff;
                                        "
                                        @click="
                                          cargarCanjesBenef(
                                            index,
                                            ben.codigoProducto
                                          )
                                        "
                                      >
                                        {{ ben.detalleProducto }}
                                      </td>
                                      <td
                                        class="text-start"
                                        v-else
                                        @click="
                                          cargarCanjesBenef(
                                            index,
                                            ben.codigoProducto
                                          )
                                        "
                                      >
                                        {{ ben.detalleProducto }}
                                      </td>

                                      <td
                                        v-if="
                                          status_select_benef_doc ==
                                          ben.codigoProducto
                                        "
                                        style="
                                          background-color: #139ab8;
                                          color: #ffffff;
                                        "
                                        @click="
                                          cargarCanjesBenef(
                                            index,
                                            ben.codigoProducto
                                          )
                                        "
                                      >
                                        {{ ben.vecesCanje }}
                                      </td>
                                      <td
                                        v-else
                                        @click="
                                          cargarCanjesBenef(
                                            index,
                                            ben.codigoProducto
                                          )
                                        "
                                      >
                                        {{ ben.vecesCanje }}
                                      </td>

                                      <td
                                        v-if="
                                          status_select_benef_doc ==
                                          ben.codigoProducto
                                        "
                                        style="
                                          background-color: #139ab8;
                                          color: #ffffff;
                                        "
                                        @click="
                                          cargarCanjesBenef(
                                            index,
                                            ben.codigoProducto
                                          )
                                        "
                                      >
                                        {{ ben.cantidadCanje }}
                                      </td>
                                      <td
                                        v-else
                                        @click="
                                          cargarCanjesBenef(
                                            index,
                                            ben.codigoProducto
                                          )
                                        "
                                      >
                                        {{ ben.cantidadCanje }}
                                      </td>
                                    </tr>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div v-if="codigoPromocion != ''" class="col-md-6">
                            <div class="row">
                              <div class="fw-bold text-start">
                                <h6
                                  class="fw-bold text-start"
                                  style="font-size: 12px"
                                >
                                  Producto:&nbsp;<label
                                    style="
                                      background-color: #d4e6f1;
                                      color: #000000;
                                      border: 1px #000;
                                      border-style: ridge;
                                    "
                                    >&nbsp;&nbsp;{{
                                      descripcionProductSelectBenef
                                    }}&nbsp;&nbsp;</label
                                  >
                                </h6>
                              </div>
                              <h6
                                class="fw-bold text-start"
                                style="font-size: 12px"
                              >
                                Documentos de canje:
                              </h6>
                              <div class="col-md-12">
                                <div
                                  class="input-group"
                                  style="font-size: 12px"
                                >
                                  <label class="fw-bold"
                                    >Buscar:&nbsp;&nbsp;</label
                                  >
                                  <input
                                    v-if="selectCodDes == 0"
                                    type="text"
                                    v-model="buscarSerieDocLk"
                                    class="form-control-sm form-control col-md-3"
                                    placeholder="Serie de documento"
                                    style="font-size: 12px"
                                    @keyup.enter="buscarSerieDocumento()"
                                  />
                                </div>
                              </div>
                              <br />
                              <div
                                class="table-responsive"
                                style="
                                  overflow-y: scroll;
                                  min-height: 50px;
                                  max-height: 250px;
                                  border: 1.5px;
                                  border-style: ridge;
                                "
                              >
                                <table
                                  class="table table-bordered table-striped table-sm tab-head"
                                  style="font-size: 10px"
                                >
                                  <thead class="table-light">
                                    <tr class="tab-cabecere">
                                      <th>Código<br />Farmacia</th>
                                      <th>Farmacia</th>
                                      <th>Serie</th>
                                      <th>Fecha</th>
                                      <th>Nro.<br />canjes</th>
                                      <th>Cant.<br />canjes</th>
                                    </tr>
                                  </thead>
                                  <tr
                                    v-for="(
                                      acact, indexx
                                    ) in arrayDocumentosCanje"
                                    :key="indexx"
                                    style="border: 0.5px"
                                  >
                                    <td
                                      v-if="
                                        status_select_doc ==
                                        acact.SERIE_DOCUMENTO
                                      "
                                      style="
                                        background-color: #139ab8;
                                        color: #ffffff;
                                      "
                                      class="text-start"
                                      @click="
                                        cargarDocConsumoSelect(
                                          acact.SERIE_DOCUMENTO
                                        )
                                      "
                                    >
                                      {{ acact.COD_FARMACIA }}
                                    </td>
                                    <td
                                      v-else
                                      class="text-start"
                                      @click="
                                        cargarDocConsumoSelect(
                                          acact.SERIE_DOCUMENTO
                                        )
                                      "
                                    >
                                      {{ acact.COD_FARMACIA }}
                                    </td>

                                    <td
                                      v-if="
                                        status_select_doc ==
                                        acact.SERIE_DOCUMENTO
                                      "
                                      style="
                                        background-color: #139ab8;
                                        color: #ffffff;
                                      "
                                      class="text-start"
                                      @click="
                                        cargarDocConsumoSelect(
                                          acact.SERIE_DOCUMENTO
                                        )
                                      "
                                    >
                                      {{ acact.DES_FARMACIA }}
                                    </td>
                                    <td
                                      v-else
                                      class="text-start"
                                      @click="
                                        cargarDocConsumoSelect(
                                          acact.SERIE_DOCUMENTO
                                        )
                                      "
                                    >
                                      {{ acact.DES_FARMACIA }}
                                    </td>

                                    <td
                                      v-if="
                                        status_select_doc ==
                                        acact.SERIE_DOCUMENTO
                                      "
                                      style="
                                        background-color: #139ab8;
                                        color: #ffffff;
                                      "
                                      class="text-start"
                                      @click="
                                        cargarDocConsumoSelect(
                                          acact.SERIE_DOCUMENTO
                                        )
                                      "
                                    >
                                      {{ acact.SERIE_DOCUMENTO }}
                                    </td>
                                    <td
                                      v-else
                                      class="text-start"
                                      @click="
                                        cargarDocConsumoSelect(
                                          acact.SERIE_DOCUMENTO
                                        )
                                      "
                                    >
                                      {{ acact.SERIE_DOCUMENTO }}
                                    </td>
                                    <td
                                      v-if="
                                        status_select_doc ==
                                        acact.SERIE_DOCUMENTO
                                      "
                                      style="
                                        background-color: #139ab8;
                                        color: #ffffff;
                                      "
                                      class="text-start"
                                      @click="
                                        cargarDocConsumoSelect(
                                          acact.SERIE_DOCUMENTO
                                        )
                                      "
                                    >
                                      {{ acact.FECHA_DOCUMENTO }}
                                    </td>
                                    <td
                                      v-else
                                      class="text-start"
                                      @click="
                                        cargarDocConsumoSelect(
                                          acact.SERIE_DOCUMENTO
                                        )
                                      "
                                    >
                                      {{ acact.FECHA_DOCUMENTO }}
                                    </td>
                                    <td
                                      v-if="
                                        status_select_doc ==
                                        acact.SERIE_DOCUMENTO
                                      "
                                      style="
                                        background-color: #139ab8;
                                        color: #ffffff;
                                      "
                                      
                                      @click="
                                        cargarDocConsumoSelect(
                                          acact.SERIE_DOCUMENTO
                                        )
                                      "
                                    >
                                      {{ acact.VECES_CANJE }}
                                    </td>
                                    <td
                                      v-else
                                     
                                      @click="
                                        cargarDocConsumoSelect(
                                          acact.SERIE_DOCUMENTO
                                        )
                                      "
                                    >
                                      {{ acact.VECES_CANJE }}
                                    </td>
                                    <td
                                      v-if="
                                        status_select_doc ==
                                        acact.SERIE_DOCUMENTO
                                      "
                                      style="
                                        background-color: #139ab8;
                                        color: #ffffff;
                                      "
                                      class="text-start"
                                      @click="
                                        cargarDocConsumoSelect(
                                          acact.SERIE_DOCUMENTO
                                        )
                                      "
                                    >
                                      {{ acact.CANTIDAD_CANJE }}
                                    </td>
                                    <td
                                      v-else
                                      class="text-start"
                                      @click="
                                        cargarDocConsumoSelect(
                                          acact.SERIE_DOCUMENTO
                                        )
                                      "
                                    >
                                      {{ acact.CANTIDAD_CANJE }}
                                    </td>
                                  </tr>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>

                        
                        <!--fin del row-->

                        <!--detalle documentos-->
                        <div v-if="codigoPromocion != ''" class="row">
                          <div class="fw-bold text-start">
                            <h6
                              v-if="status_select_doc_nombre != ''"
                              class="fw-bold text-start"
                              style="font-size: 12px"
                            >
                              Documento de canje seleccionado: &nbsp;<label
                                style="
                                  background-color: #d4e6f1;
                                  color: #000000;
                                  border: 1px #000;
                                  border-style: ridge;
                                "
                                >&nbsp;&nbsp;{{
                                  status_select_doc_nombre
                                }}&nbsp;&nbsp;</label
                              >
                            </h6>
                          </div>
                          <div class="row">
                            <div class="col-md-8">

                          <h6
                            class="fw-bold text-start"
                            style="font-size: 12px"
                          >
                            Documentos de consumo (cupones):
                          </h6>
                          </div>
                          <div class="col-md-4">
                            <h6
                            class="fw-bold text-start"
                            style="font-size: 12px"
                          >
                          &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;Total cantidad utilizada:&nbsp;&nbsp;{{sumaDocConsumo}}
                          </h6>
                          </div>
                        </div>
                          <div
                            class="table-responsive"
                            style="
                              font-size: 10px;
                              min-height: 50px;
                              max-height: 250px;
                              overflow-y: scroll;
                              border: 1.5px;
                              border-style: ridge;
                            "
                          >
                            <table
                              class="table table-bordered table-striped table-sm tab-head"
                              style="font-size: 10px"
                            >
                              <thead class="table-light">
                                <tr class="tab-cabecere">
                                  <th>Código<br />Farmacia</th>
                                  <th>Farmacia</th>
                                  <th>Serie</th>
                                  <!--<th>Consumo</th>-->
                                  <th>Fecha</th>
                                  <th>Código<br />Producto</th>
                                  <th>Producto</th>
                                  <th>Cant.<br />utilizada</th>
                                  <th>Cant.<br />comprada</th>
                                </tr>
                              </thead>
                              <tr
                                v-for="(
                                  acact, indexx
                                ) in arrayDocumentosConsumo"
                                :key="indexx"
                                style="border: 0.5px"
                              >
                                <td class="text-start">
                                  {{ acact.COD_FARMACIA }}
                                </td>
                                <td class="text-start">
                                  {{ acact.DES_FARMACIA }}
                                </td>
                                <td>{{ acact.SERIE_DOCUMENTO }}</td>
                                <!--<td>{{acact.DOCUMENTO_CANJE}}</td>-->
                                <td>{{ acact.FECHA_DOCUMENTO }}</td>
                                <td>{{ acact.COD_PRODUCTO }}</td>
                                <td>{{ acact.DES_PRODUCTO }}</td>
                                <td>{{ acact.CANTIDAD_PUNTOS }}</td>
                                <td>{{ acact.CANTIDAD }}</td>
                                
                              </tr>
                            </table>
                          </div>
                        </div>
                        <!-- fin detalles documentos-->
                      </div>
                      <!---->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--fin Beneficios canje-->
          </div>
        </div>
        <!--- -->

        <!-- borrado -->

        <!-- fin de borrado -->
      </template>
      <!-- fin ver listado editar promociones -->
    </div>
  </div>
  <!-- incio de modal encabezado-->
  <div
    class="modal fade"
    tabindex="-1"
    :class="{ mostrar: modalCabecera }"
    role="dialog"
    aria-labelledby="staticBackdropLabel"
    style="display: none"
    aria-hidden="true"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
  >
    <div class="modal-dialog modal-xl">
      <br />
      <div class="modal-content">
        <div class="modal-header" style="height: 10px">
          <h6
            class="modal-title"
            id="staticBackdropLabel"
            v-text="tituloModal"
          ></h6>
          <button
            type="button"
            class="btn-close btn-sm"
            data-bs-dismiss="modal"
            @click.prevent="cerrarPromocionTodoTodo()"
            aria-label="Close"
          ></button>
        </div>
        <!--<div class="modal-body">-->
        <!-- Contenido del modal -->
        <!-- inicio encabezado de promociones-- detalle detalle -->
        <!-- <Promo :codPromoL="codigoPromocion" ></Promo> -->

        <div class="card-body">
          <!--<div class="modal-header" style="font-size: 12px; height: 10px">
            <h5
                class="modal-title"
                id="staticBackdropLabel"
                v-text="tituloModal"
              ></h5>
            <button
              type="button "
              class="btn-close btn btn-sm"
              data-bs-dismiss="modal"
              @click="cerrarModalVi()"
              aria-label="Close"
            ></button>
          </div>-->
          <div class="form-group row">
            <!-- Incio Mostrar encabezado promocion -->
            <div class="container">
              <div class="card">
                <div
                  class="text-start fw-bold"
                  style="
                    background: #ebeef6;
                    font-size: 12px;
                    height: 30px;
                    color: #000000;
                  "
                >
                  <p>&nbsp;&nbsp;Detalle de cabecera</p>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div
                      class="col-md-12"
                      style="font-size: 10px; min-height: 50px"
                    ></div>
                    <table
                      v-if="codigoPromocion"
                      style="text-align: left; font-size: 12px; border: 1"
                      cellpadding="0"
                      cellspacing="0"
                      class="table table-sm table-hover"
                    >
                      <tbody>
                        <tr>
                          <th class="text-end" scope="row" style="width: 10rem">
                            Código:
                          </th>
                          <td v-text="codigoPromocion" style="width: 25px"></td>
                          <th class="text-end" scope="row" style="width: 50px">
                            Fecha&nbsp;inicio:
                          </th>
                          <td style="width: 15rem" v-text="fechaInicio"></td>
                          <th class="text-end" scope="row" style="width: 15rem">
                            Fecha fin:&nbsp;&nbsp;&nbsp;
                          </th>
                          <td style="width: 15rem" v-text="fechaFin"></td>
                          <th class="text-end" scope="row" style="width: 10rem">
                            Estado:&nbsp;&nbsp;&nbsp;
                          </th>
                          <td
                            v-if="estadoPromocion == 'Pendiente'"
                            v-text="estadoPromocion"
                            style="background-color: #8fe88a"
                          ></td>
                          <td
                            v-if="estadoPromocion == 'Activo'"
                            v-text="estadoPromocion"
                            style="background-color: #8fe88a"
                          ></td>
                          <td
                            v-if="estadoPromocion == 'Finalizado'"
                            v-text="estadoPromocion"
                            style="background-color: #f96443"
                          ></td>
                        </tr>
                        <tr>
                          <th class="text-end" scope="row">Nombre:</th>
                          <td colspan="7" v-text="nombrePromocion"></td>
                        </tr>
                        <tr>
                          <th class="text-end" scope="row">Descripción:</th>
                          <td colspan="7">
                            <p>{{ observacionesPromocion }}</p>
                          </td>
                        </tr>

                        <tr class="align-middle">
                          <th class="text-end CellWithComment" scope="row">
                            Descripción&nbsp;<br />mecánica:&nbsp;<i
                              class="fas fa-question-circle"
                            ></i>
                            <!--<span class="text-start CellComment" style="font-weight:normal;">-->
                            <!--Tool tip de mensajes-->
                            <div class="card text-start CellComment" id="span1">
                              <div class="card-header" style="top: -15px">
                                Descripción&nbsp;mecánica
                              </div>
                              <div
                                class="men-tooltip card-body text-start lh-sm"
                                style="
                                  top: -5px;
                                  min-height: 25px;
                                  max-height: 150px;
                                "
                              >
                                <!--<p style="text-align: justify">-->
                                <p>
                                  Indica la relación que existe entre la
                                  acumulación y la cantidad de producto a
                                  recibir como beneficio.
                                </p>
                              </div>
                            </div>
                            <!--Tool tip de mensajes-->
                            <!--
                              -&nbsp;Descripción&nbsp;mecánica<br>
                              </span> -->
                          </th>
                          <td
                            v-text="mecanica"
                            style="
                              width: 30rem;
                              border: 1.25px;
                              border-style: ridge;
                            "
                          ></td>
                          <th
                            class="text-end CellWithComment"
                            scope="row"
                            style="width: 15rem"
                          >
                            Modalidad:&nbsp;<i
                              class="fas fa-question-circle"
                            ></i>

                            <div class="card text-start CellComment" id="span1">
                              <div class="card-header" style="top: -15px">
                                Modalidad
                              </div>
                              <div
                                class="men-tooltip card-body text-start lh-sm"
                                style="
                                  top: -5px;
                                  min-height: 25px;
                                  max-height: 150px;
                                "
                              >
                                <p class="card-text">
                                  Tipo de clasificación de la promoción.
                                </p>
                              </div>
                            </div>
                          </th>
                          <td
                            v-text="tipoMF"
                            style="
                              background-color: #ebeef6;
                              border: 1.25px;
                              border-style: ridge;
                            "
                            colspan="2"
                          ></td>

                          <th
                            class="text-end CellWithComment"
                            scope="row"
                            style="width: 8rem"
                          >
                            Tipo acumulación:&nbsp;<i
                              class="fas fa-question-circle"
                            ></i>
                            <div class="card text-start CellComment" id="span1">
                              <div class="card-header" style="top: -15px">
                                Tipo acumulación
                              </div>
                              <div
                                class="men-tooltip card-body text-start lh-sm"
                                style="
                                  top: -5px;
                                  min-height: 25px;
                                  max-height: 250px;
                                "
                              >
                                <p class="card-text">
                                  Tipo de comportamiento de la promoción.
                                </p>
                                <p class="card-text">
                                  Acumulable: El cliente por comprar el producto
                                  acumula hasta cumplir condición.
                                </p>
                                <p class="card-text">
                                  No Acumulable: El cliente debe comprar la
                                  cantidad necesaria para cumplir condición en
                                  una sola factura.
                                </p>
                              </div>
                            </div>
                          </th>
                          <td
                            style="
                              background-color: #ebeef6;
                              border: 1.25px;
                              border-style: ridge;
                            "
                            colspan="2"
                            v-text="tipoAcumulacion"
                          ></td>
                        </tr>

                        <tr class="align-middle">
                          <th class="text-end CellWithComment" scope="row">
                            Inicio de&nbsp;<br />acumulación:&nbsp;<i
                              class="fas fa-question-circle"
                            ></i>
                            <div class="card text-start CellComment" id="span1">
                              <div class="card-header" style="top: -15px">
                                Inicio de acumulación
                              </div>
                              <div
                                class="men-tooltip card-body text-start lh-sm"
                                style="
                                  top: -5px;
                                  min-height: 25px;
                                  max-height: 200px;
                                "
                              >
                                <p class="card-text">
                                  Fecha, hora y minutos desde cuando va a
                                  comenzar a tener acumulaciones de productos
                                  según la condición. Esta fecha se controla con
                                  la configuración de “Pendiente canje”.
                                </p>
                              </div>
                            </div>
                          </th>
                          <td
                            style="
                              background-color: #139ab8;
                              color: #ffffff;
                              border: 1.5px;
                              border-style: ridge;
                              width: 10rem;
                            "
                            v-text="fechaInicioAcumulacion"
                          ></td>
                          <th class="text-end CellWithComment" scope="row">
                            Período de<br />canje:&nbsp;<i
                              class="fas fa-question-circle"
                            ></i>
                            <div class="card text-start CellComment" id="span1">
                              <div class="card-header" style="top: -15px">
                                Período de canje
                              </div>
                              <div
                                class="men-tooltip card-body text-start lh-sm"
                                style="
                                  top: -5px;
                                  min-height: 25px;
                                  max-height: 150px;
                                "
                              >
                                <p class="card-text">
                                  Número de meses con los cuales la promoción se
                                  puede reiniciar los limites de aplicación de
                                  la promoción.
                                </p>
                              </div>
                            </div>
                          </th>
                          <td
                            style="
                              background-color: #139ab8;
                              color: #ffffff;
                              border: 1.5px;
                              border-style: ridge;
                            "
                            colspan="2"
                          >
                            {{ periodoCanje }}&nbsp;{{ unidadPeriodoCanje }}
                          </td>
                          <th
                            class="text-end CellWithComment"
                            scope="row"
                            style="width: 10rem"
                            v-if="tipoMF != 'Tratamiento Completo'"
                          >
                            Pendiente canje:&nbsp;<i
                              class="fas fa-question-circle"
                            ></i>
                            <div class="card text-start CellComment" id="span1">
                              <div class="card-header" style="top: -15px">
                                Pendiente canje
                              </div>
                              <div
                                class="men-tooltip card-body text-start lh-sm"
                                style="
                                  top: -5px;
                                  min-height: 25px;
                                  max-height: 150px;
                                "
                              >
                                <p class="card-text">
                                  Número de meses a partir de la fecha actual
                                  hacia atrás para poder considerar las unidades
                                  acumuladas y poder determinar si aplica la
                                  entrega del beneficio.
                                </p>
                              </div>
                            </div>
                          </th>
                          <td
                            v-if="tipoMF != 'Tratamiento Completo'"
                            style="
                              background-color: #139ab8;
                              color: #ffffff;
                              border: 1.5px;
                              border-style: ridge;
                            "
                            colspan="2"
                          >
                            {{ mesPendienteCanje }}&nbsp;{{
                              unidadPeriodoCanje
                            }}
                          </td>
                        </tr>
                        <tr>
                          <th class="text-end" scope="row">Responsable:</th>
                          <td
                            v-text="responsablePromo"
                            style="width: 15rem"
                          ></td>
                          <th
                            class="text-end"
                            scope="row"
                            colspan="2"
                            style="width: 10rem"
                          >
                            Línea Comercial&nbsp;Solicitante:
                          </th>
                          <td
                            v-text="lineaCSolicitante"
                            style="width: 15rem"
                            colspan="4"
                          ></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <!-- Fin Mostrar encabezado promocion -->
            <!-- condiciones simples -->

            <!--condiciones-->
            <div class="container" style="font-size: 12px">
              <div class="card">
                <div class="accordion" id="accordionExample">
                  <div class="accordion-item">
                    <h1 class="accordion-header" id="headingOne">
                      <button
                        class="accordion-button btn btn-sm fw-bold"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                        style="
                          background: #ebeef6;
                          font-size: 12px;
                          height: 8px;
                          color: #000000;
                        "
                      >
                        Condiciones
                      </button>
                    </h1>
                    <div
                      id="collapseOne"
                      class="accordion-collapse collapse show"
                      aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample"
                    >
                      <div
                        class="accordion-body"
                        style="font-size: 11px; height: 375px"
                      >
                        <!--
                      <div class="table-responsive col-md-6" v-for="(aBen,index) in arrayBeneficiosProcess" :key="index">
                       <table class="table table-bordered table-striped table-sm">
                              <tr>
                                <th>Código</th>
                                <th>Descripción</th>
                                <th>Estado</th>
                              </tr>
                              <tr v-for="(cond,indexx) in aBen.cod" :key="indexx">
                                <td>{{cond.codigoProducto}}</td>
                                <td>{{cond.descripcionProducto}}</td>
                                <td>{{cond.status}}</td>
                              </tr>
                              
                            </table> 
                      </div>
                      -->
                        <div class="row">
                          <div class="col-md-5">
                            <div class="input-group" style="font-size: 13px">
                              <label class="fw-bold"
                                >Buscar:&nbsp;&nbsp;&nbsp;</label
                              ><input
                                type="text"
                                v-model="buscarCondicionesLk"
                                class="form-control-sm form-control col-md-2"
                                placeholder="Código o nombre de producto"
                                style="font-size: 12px"
                                @keyup.enter="buscarCondicionesLike()"
                              />
                            </div>
                          </div>
                          <div class="text-end col-md-1" style="height: 5px">
                            <table
                              class="table-sm text-end"
                              style="font-size: 11px; width: 30px"
                            >
                              <tr>
                                <th class="text-end CellWithComment1">
                                  &nbsp;&nbsp;<i
                                    class="fas fa-question-circle"
                                    style="font-size: 13px"
                                  ></i>
                                  <div
                                    class="card text-start CellComment1"
                                    id="span2"
                                  >
                                    <div
                                      class="card-header fw-bold"
                                      style="font-size: 12px; top: -15px"
                                    >
                                      Condiciones
                                    </div>
                                    <div
                                      class="men-tooltip card-body text-start lh-sm"
                                      style="
                                        top: -5px;
                                        min-height: 25px;
                                        max-height: 200px;
                                      "
                                    >
                                      <p
                                        class="card-text"
                                        style="text-align: justify"
                                      >
                                        Buscador de productos: Filtro por nombre
                                        de producto que son parte de las
                                        condiciones.
                                      </p>
                                      <p
                                        class="card-text"
                                        
                                      >
                                        <i
                                          class="far fa-square"
                                          style="background: #80d1e7"
                                        ></i
                                        >&nbsp;Valor que puede acumular entre
                                        todos los productos participantes.
                                      </p>
                                      <p
                                        class="card-text"
                                        
                                      >
                                        <i
                                          class="far fa-square"
                                          style="background: #8fe88a"
                                        ></i
                                        >&nbsp;Valor que puede acumular de
                                        manera individual por cada producto
                                        participante.
                                      </p>
                                    </div>
                                  </div>
                                </th>
                              </tr>
                            </table>
                          </div>
                          <div class="col-md-5" style="font-size: 14px">
                            <div @click="verConfiguracion()">
                              <i class="fa fa-bars" aria-hidden="true"></i
                              >&nbsp;Ver Configuración
                            </div>
                          </div>
                          <div
                            class="col-md-1 text-end"
                            style="font-size: 11px"
                          >
                            <table class="table-sm">
                              <tr>
                                <td class="text-end CellWithComment1">
                                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i
                                    class="fas fa-question-circle"
                                    style="font-size: 14px"
                                  ></i>
                                  <div
                                    class="card text-start CellComment1"
                                    id="span2"
                                  >
                                    <div
                                      class="card-header fw-bold"
                                      style="font-size: 12px; top: -15px"
                                    >
                                      Configuración
                                    </div>
                                    <div
                                      class="men-tooltip card-body text-start lh-sm"
                                      style="
                                        top: -5px;
                                        min-height: 25px;
                                        max-height: 150px;
                                      "
                                    >
                                      <p class="card-text">
                                        Detalle de la configuración de la
                                        promoción con los operadores lógicos
                                        Y/O.
                                      </p>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </table>
                          </div>
                        </div>
                        <br />
                        <!-- -->
                        <div class="row">
                          <div class="col-md-7">
                            <div
                              style="
                                font-size: 10px;
                                min-height: 50px;
                                max-height: 150px;
                                overflow-y: scroll;
                                border: 1.5px;
                                border-style: ridge;
                              "
                            >
                              <div
                                class="table-responsive"
                                v-for="(aBen, index) in arrayCondicionesProcess_Prm"
                                :key="index"
                              >
                                <div class="text-start fw-bold">
                                  <labal style="font-size: 12px"
                                    >Opción {{ index + 1 }}:</labal
                                  >
                                </div>

                                <table
                                  class="table table-bordered table-striped table-sm tab-head"
                                  style="font-size: 10px; border: 0.5px"
                                >
                                  <thead class="table-light">
                                    <tr class="tab-cabecere">
                                      <th>Código</th>
                                      <th>Descripción</th>
                                      <th class="text-end">Cant.&nbsp;Req.</th>
                                      <th>Acum.Cajas</th>
                                      <th>Estado</th>
                                    </tr>
                                  </thead>
                                  <tr
                                    v-for="(cond, indexx) in aBen.cod"
                                    :key="indexx"
                                    style="border: 0.5px"
                                  >
                                    <td class="text-start">
                                      {{ cond.codigoProducto }}
                                    </td>
                                    <td class="text-start">
                                      {{ cond.descripcionProducto }}
                                    </td>
                                    <td
                                      v-if="cond.tipoAC == '0'"
                                      style="background: #80d1e7"
                                    >
                                      {{ cond.cantidad }}
                                    </td>
                                    <td v-else style="background: #8fe88a">
                                      {{ cond.cantidad }}
                                    </td>
                                    <td v-if="cond.acumulacionCajas == true">
                                      SI
                                    </td>
                                    <td v-if="cond.acumulacionCajas == false">
                                      NO
                                    </td>
                                    <td>{{ cond.status }}</td>
                                  </tr>
                                </table>
                              </div>
                            </div>
                            <div class="row"></div>
                            <div class="fw-bold text-start">
                              <h7 style="font-size: 12px">
                                Sucursales participantes en la promoción:
                              </h7>
                            </div>
                            <div
                              class="table-responsive"
                              style="
                                font-size: 10px;
                                min-height: 50px;
                                max-height: 150px;
                                overflow-y: scroll;
                                border: 1.5px;
                                border-style: ridge;
                              "
                            >
                              <table
                                class="table table-bordered table-sm tab-head"
                              >
                                <thead class="table-light">
                                  <tr class="tab-cabecere">
                                    <th>Código</th>
                                    <th>Sucursal</th>
                                    <th>Oficinas</th>
                                  </tr>
                                </thead>
                                <tr
                                  v-for="(
                                    cond, index
                                  ) in arraySucursalesProcess"
                                  :key="index"
                                  style="border: 0.5px"
                                >
                                  <td v-if="cond.Oficinas != 0">
                                    {{ cond.Codigo }}
                                  </td>
                                  <td
                                    v-if="cond.Oficinas != 0"
                                    class="text-start"
                                  >
                                    {{ cond.Sucursal }}
                                  </td>
                                  <td v-if="cond.Oficinas != 0">
                                    {{ cond.Oficinas }}
                                  </td>
                                </tr>
                              </table>
                            </div>
                          </div>
                          <!--
                            <div
                            class="table-responsive col-md-5"
                            v-if="statusConfig == 1"
                          > -->
                          <div class="table-responsive col-md-5">
                            <!--arbol-->
                            <div
                              class="table-responsive"
                              style="
                                font-size: 11px;
                                min-height: 100px;
                                max-height: 250px;
                                overflow-y: scroll;
                              "
                            >
                              <ul style="text-align: left">
                                <li
                                  class="list-group-item"
                                  v-for="(item, indexx) in arrayItem"
                                  :key="indexx"
                                >
                                  <label
                                    class="fw-bold text-white"
                                    v-if="padreSeleccionado == indexx"
                                    style="background: #06758E; text-white"
                                    @click="
                                      seleccionarPadre(item.codigoGrupo, indexx)
                                    "
                                    >&nbsp;{{ item.nombreGrupo }}&nbsp;</label
                                  >&nbsp;&nbsp;
                                  <label
                                    class="fw-bold"
                                    v-else
                                    style="background: none"
                                    @click="
                                      seleccionarPadre(item.codigoGrupo, indexx)
                                    "
                                    >{{ item.nombreGrupo }}</label
                                  >&nbsp;&nbsp;
                                  <label
                                    v-if="estado_proceso === 1"
                                    class="col-md-1"
                                    @click="
                                      eliminarPadre(indexx, item.codigoGrupo)
                                    "
                                    ><i class="far fa-trash-alt"></i
                                  ></label>

                                  <ul>
                                    <li
                                      v-for="(it, index) in item.condiciones"
                                      :key="index"
                                      style="
                                        list-style: none;
                                        list-style-position: inside;
                                      "
                                    >
                                      <div v-if="it.operador === 'AND'">
                                        <ul>
                                          <li
                                            v-if="
                                              it.tipo == 'productos' ||
                                              it.tipo == 'productoscombinados'
                                            "
                                            style="
                                              list-style: none;
                                              list-style-position: inside;
                                            "
                                          >
                                            <label
                                              @click="
                                                seleccionarHijo(
                                                  index,
                                                  it.idHijo,
                                                  it.tipo
                                                )
                                              "
                                            >
                                              <i class="fas fa-dot-circle"></i
                                              >&nbsp;{{
                                                it.mensajeCondicion
                                              }}
                                              &nbsp;productos&nbsp;:&nbsp;</label
                                            >
                                            <label
                                              v-if="
                                                it.codigoProducto.toString()
                                                  .length > 50
                                              "
                                              style="width: 90%"
                                            >
                                              {{
                                                it.codigoProducto
                                                  .toString()
                                                  .substring(0, 110) + "......."
                                              }}
                                              <a
                                                @click="
                                                  verProdCod(
                                                    it.codigoProducto.toString(),
                                                    0
                                                  )
                                                "
                                                ><i
                                                  class="fas fa-plus-square"
                                                ></i
                                              ></a>
                                            </label>
                                            <label v-else>
                                              {{
                                                it.codigoProducto.toString()
                                              }}</label
                                            >

                                            <div>
                                              Cant.:{{ it.cantidad }}

                                              <!--<div>-->
                                              <!-- productos -->
                                              &nbsp;&nbsp;&nbsp;Relación&nbsp;acumulación:&nbsp;<label
                                                v-if="it.relacion == 1"
                                                >Individual.</label
                                              ><label v-else
                                                >Entre todos.</label
                                              >
                                              &nbsp;&nbsp;<label
                                                v-if="it.acumulacionCajas"
                                                >Acumula cajas.</label
                                              >
                                              &nbsp;&nbsp;<label
                                                v-if="it.acumulable"
                                                >Es acumulable.</label
                                              >
                                              <!--</div>-->
                                              <!-- menu menu de condi -->
                                              <div
                                                v-if="
                                                  estado_proceso === 1 &&
                                                  padreSeleccionado === indexx
                                                "
                                                class="btn-group dropend"
                                              >
                                                <button
                                                  class="btn btn-sm btn-sm"
                                                  style="font-size: 11px"
                                                  type="button"
                                                >
                                                  <i class="fas fa-tools"></i>
                                                </button>
                                                <button
                                                  type="button"
                                                  class="btn btn-sm dropdown-toggle dropdown-toggle-split"
                                                  data-bs-toggle="dropdown"
                                                  aria-expanded="false"
                                                >
                                                  <span class="visually-hidden"
                                                    >Toggle Dropdown</span
                                                  >
                                                </button>
                                                <ul class="dropdown-menu">
                                                  <li>
                                                    <a
                                                      class="dropdown-item"
                                                      style="font-size: 12px"
                                                      @click="
                                                        abrirModalCondicionesProdEdit(
                                                          index,
                                                          it.idHijo,
                                                          it.idPadre,
                                                          it
                                                        )
                                                      "
                                                      ><i
                                                        class="fas fa-pencil-alt"
                                                      ></i
                                                      >&nbsp;Editar</a
                                                    >
                                                  </li>
                                                  <li>
                                                    <a
                                                      class="dropdown-item"
                                                      style="font-size: 12px"
                                                      @click="
                                                        eliminarHijo(
                                                          index,
                                                          it.idHijo,
                                                          it.idPadre
                                                        )
                                                      "
                                                      ><i class="fas fa-ban"></i
                                                      >&nbsp;Eliminar</a
                                                    >
                                                  </li>
                                                </ul>
                                              </div>
                                              <!-- fin menu menu cond -->
                                            </div>
                                          </li>
                                          <li v-else style="list-style: none">
                                            <label
                                              @click="
                                                seleccionarHijo(
                                                  index,
                                                  it.idHijo,
                                                  it.tipo
                                                )
                                              "
                                              ><i class="fas fa-dot-circle"></i
                                              >&nbsp;{{ it.mensajeCondicion
                                              }}{{ it.tipo }}:{{ it.sucursal
                                              }}{{ it.region }}{{ it.provincia
                                              }}{{ it.ciudad }}{{ it.oficina
                                              }}{{ it.segmento }}</label
                                            >:

                                            <!-- menu menu de condi -->
                                            <div
                                              v-if="
                                                estado_proceso === 1 &&
                                                padreSeleccionado === indexx
                                              "
                                              class="btn-group dropend"
                                            >
                                              <button
                                                class="btn btn-sm btn-sm"
                                                style="font-size: 11px"
                                                type="button"
                                              >
                                                <i class="fas fa-tools"></i>
                                              </button>
                                              <button
                                                type="button"
                                                class="btn btn-sm dropdown-toggle dropdown-toggle-split"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                              >
                                                <span class="visually-hidden"
                                                  >Toggle Dropdown</span
                                                >
                                              </button>
                                              <ul class="dropdown-menu">
                                                <li>
                                                  <a
                                                    class="dropdown-item"
                                                    style="font-size: 12px"
                                                    @click="
                                                      abrirModalProvLabSecCondicionEdit(
                                                        index,
                                                        it.idHijo,
                                                        it.idPadre,
                                                        it
                                                      )
                                                    "
                                                    ><i
                                                      class="fas fa-pencil-alt"
                                                    ></i
                                                    >&nbsp;Editar</a
                                                  >
                                                </li>
                                                <li>
                                                  <a
                                                    class="dropdown-item"
                                                    style="font-size: 12px"
                                                    @click="
                                                      eliminarHijo(
                                                        index,
                                                        it.idHijo,
                                                        it.idPadre
                                                      )
                                                    "
                                                    ><i class="fas fa-ban"></i
                                                    >&nbsp;Eliminar</a
                                                  >
                                                </li>
                                              </ul>
                                            </div>
                                            <!-- fin menu menu cond -->
                                            <div>
                                              &nbsp;&nbsp;&nbsp;Aplica&nbsp;para:&nbsp;<label
                                                v-if="it.condicionAcumulacion"
                                                >Acumulación</label
                                              >&nbsp;&nbsp;<label
                                                v-if="it.condicionCanje"
                                                >-&nbsp;Canje</label
                                              >
                                            </div>
                                          </li>
                                        </ul>
                                      </div>
                                      <div v-else>
                                        <div
                                          v-if="
                                            it.tipo == 'productos' ||
                                            it.tipo == 'productoscombinados'
                                          "
                                        >
                                          <label
                                            @click="
                                              seleccionarHijo(
                                                index,
                                                it.idHijo,
                                                it.tipo
                                              )
                                            "
                                            ><i
                                              class="fas fa-arrow-circle-right"
                                            ></i
                                            >&nbsp;{{
                                              it.mensajeCondicion
                                            }}
                                            &nbsp;productos&nbsp;:</label
                                          >
                                          <label
                                            v-if="
                                              it.codigoProducto.toString()
                                                .length > 50
                                            "
                                            style="width: 90%"
                                          >
                                            {{
                                              it.codigoProducto
                                                .toString()
                                                .substring(0, 110) + "......."
                                            }}
                                            <a
                                              @click="
                                                verProdCod(
                                                  it.codigoProducto.toString(),
                                                  0
                                                )
                                              "
                                              ><i class="fas fa-plus-square"></i
                                            ></a>
                                          </label>
                                          <label v-else>
                                            {{
                                              it.codigoProducto.toString()
                                            }}</label
                                          >

                                          <div>
                                            Cant.:{{ it.cantidad }}
                                            <!--<div> -->
                                            <!-- productos -->
                                            &nbsp;&nbsp;&nbsp;Relación&nbsp;acumulación:&nbsp;<label
                                              v-if="it.relacion == 1"
                                              >Individual.</label
                                            ><label v-else>Entre todos.</label>
                                            &nbsp;&nbsp;<label
                                              v-if="it.acumulacionCajas"
                                              >Acumula cajas.</label
                                            >
                                            &nbsp;&nbsp;<label
                                              v-if="it.acumulable"
                                              >Es acumulable.</label
                                            >
                                            <!--</div>-->
                                            <!-- menu menu de condi -->
                                            <div
                                              v-if="
                                                estado_proceso === 1 &&
                                                padreSeleccionado === indexx
                                              "
                                              class="btn-group dropend"
                                            >
                                              <button
                                                class="btn btn-sm btn-sm"
                                                style="font-size: 11px"
                                                type="button"
                                              >
                                                <i class="fas fa-tools"></i>
                                              </button>
                                              <button
                                                type="button"
                                                class="btn btn-sm dropdown-toggle dropdown-toggle-split"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                              >
                                                <span class="visually-hidden"
                                                  >Toggle Dropdown</span
                                                >
                                              </button>
                                              <ul class="dropdown-menu">
                                                <li>
                                                  <a
                                                    class="dropdown-item"
                                                    style="font-size: 12px"
                                                    @click="
                                                      abrirModalCondicionesProdEdit(
                                                        index,
                                                        it.idHijo,
                                                        it.idPadre,
                                                        it
                                                      )
                                                    "
                                                    ><i
                                                      class="fas fa-pencil-alt"
                                                    ></i
                                                    >&nbsp;Editar</a
                                                  >
                                                </li>
                                                <li>
                                                  <a
                                                    class="dropdown-item"
                                                    style="font-size: 12px"
                                                    @click="
                                                      eliminarHijo(
                                                        index,
                                                        it.idHijo,
                                                        it.idPadre
                                                      )
                                                    "
                                                    ><i class="fas fa-ban"></i
                                                    >&nbsp;Eliminar</a
                                                  >
                                                </li>
                                              </ul>
                                            </div>
                                            <!-- fin menu menu cond -->
                                          </div>
                                        </div>
                                        <div v-else>
                                          <label
                                            @click="
                                              seleccionarHijo(
                                                index,
                                                it.idHijo,
                                                it.tipo
                                              )
                                            "
                                            ><i
                                              class="fas fa-arrow-circle-right"
                                            ></i
                                            >&nbsp;{{ it.mensajeCondicion
                                            }}{{ it.tipo }}:{{ it.sucursal
                                            }}{{ it.region }}{{ it.provincia
                                            }}{{ it.ciudad }}{{ it.oficina
                                            }}{{ it.segmento }}</label
                                          >:

                                          <!-- menu menu de condi -->
                                          <div
                                            v-if="
                                              estado_proceso === 1 &&
                                              padreSeleccionado === indexx
                                            "
                                            class="btn-group dropend"
                                          >
                                            <button
                                              class="btn btn-sm btn-sm"
                                              style="font-size: 11px"
                                              type="button"
                                            >
                                              <i class="fas fa-tools"></i>
                                            </button>
                                            <button
                                              type="button"
                                              class="btn btn-sm dropdown-toggle dropdown-toggle-split"
                                              data-bs-toggle="dropdown"
                                              aria-expanded="false"
                                            >
                                              <span class="visually-hidden"
                                                >Toggle Dropdown</span
                                              >
                                            </button>
                                            <ul class="dropdown-menu">
                                              <li>
                                                <a
                                                  class="dropdown-item"
                                                  style="font-size: 12px"
                                                  @click="
                                                    abrirModalProvLabSecCondicionEdit(
                                                      index,
                                                      it.idHijo,
                                                      it.idPadre,
                                                      it
                                                    )
                                                  "
                                                  ><i
                                                    class="fas fa-pencil-alt"
                                                  ></i
                                                  >&nbsp;Editar</a
                                                >
                                              </li>
                                              <li>
                                                <a
                                                  class="dropdown-item"
                                                  style="font-size: 12px"
                                                  @click="
                                                    eliminarHijo(
                                                      index,
                                                      it.idHijo,
                                                      it.idPadre
                                                    )
                                                  "
                                                  ><i class="fas fa-ban"></i
                                                  >&nbsp;Eliminar</a
                                                >
                                              </li>
                                            </ul>
                                          </div>
                                          <!-- fin menu menu cond -->
                                          <div>
                                            &nbsp;&nbsp;&nbsp;Aplica&nbsp;para:&nbsp;<label
                                              v-if="it.condicionAcumulacion"
                                              >Acumulación</label
                                            >&nbsp;&nbsp;<label
                                              v-if="it.condicionCanje"
                                              >-&nbsp;Canje</label
                                            >
                                          </div>
                                        </div>
                                      </div>
                                    </li>
                                  </ul>
                                </li>
                              </ul>
                            </div>

                            <!--arbol-->
                          </div>
                        </div>
                      </div>
                      <!---->

                      <!---->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--fin condiciones-->
            <!-- fin condiciones simples -->

            <!--Grupos de  Beneficios -->
            <div class="container" style="font-size: 12px">
              <div class="card">
                <div class="accordion" id="accordionExample1">
                  <div class="accordion-item">
                    <h1 class="accordion-header" id="headingOne1">
                      <button
                        class="accordion-button btn btn-sm fw-bold"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne1"
                        aria-expanded="true"
                        aria-controls="collapseOne1"
                        style="
                          background: #ebeef6;
                          font-size: 12px;
                          height: 8px;
                          color: #000000;
                        "
                      >
                        Beneficios
                      </button>
                    </h1>
                    <div
                      id="collapseOne1"
                      class="accordion-collapse collapse show"
                      aria-labelledby="headingOne1"
                      data-bs-parent="#accordionExample1"
                    >
                      <div
                        class="accordion-body"
                        style="
                          font-size: 11px;
                          min-height: 200px;
                          max-height: 350px;
                          overflow-y: scroll;
                        "
                      >
                        <div class="col-md-5">
                          <div class="input-group" style="font-size: 12px">
                            <label class="fw-bold"
                              >Buscar:&nbsp;&nbsp;&nbsp;</label
                            ><input
                              type="text"
                              v-model="buscarBeneficiosLk"
                              class="form-control-sm form-control col-md-2"
                              placeholder="Código o nombre de producto"
                              style="font-size: 12px"
                              @keyup.enter="buscarBeneficiosLike()"
                            />
                          </div>
                        </div>
                        <br />
                        <div
                          class="table-responsive col-md-6"
                          v-for="(aCond, index) in arrayBeneficiosProcess_Prm"
                          :key="index"
                          style="
                            font-size: 10px;
                            min-height: 50px;
                            max-height: 150px;
                            overflow-y: scroll;
                            border: 1.5px;
                            border-style: ridge;
                          "
                        >
                          <div class="fw-bold text-start">
                            <label style="font-size: 11px"
                              >Opción {{ index + 1 }}:</label
                            >
                          </div>
                          <table
                            class="table table-bordered table-striped table-sm tab-head"
                            style="font-size: 10px"
                          >
                            <thead class="table-light">
                              <tr class="tab-cabecere">
                                <th>Código</th>
                                <th>Descripción</th>
                                <th>Cant.<br />Canje</th>
                                <th>Límite&nbsp;Aplicación<br/>(Acumulación)</th>
                                <th>Límite&nbsp;Canje<br/>(Cliente)</th>
                                <th>Estado</th>
                              </tr>
                            </thead>
                            <tr
                              v-for="ben in aCond.beneficios"
                              style="border: 0.5px"
                            >
                              <td class="text-start">
                                {{ ben.codigoProducto }}
                              </td>
                              <td class="text-start">
                                {{ ben.detalleProducto }}
                              </td>
                              <td>{{ ben.cantidad }}</td>
                              <td v-if="ben.limiteAplicacion == 0">
                                Ilimitado
                              </td>
                              <td v-else>{{ ben.limiteAplicacion }}</td>
                              <td v-if="ben.limiteCanje == 0">
                                Ilimitado
                              </td>
                              <td v-else>{{ ben.limiteCanje }}</td>
                              <td>{{ ben.status }}</td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- fin Grupos de  Beneficios -->

            <!--Oficinas participantes -->
            <div class="container" style="font-size: 12px">
              <div class="card">
                <div class="accordion" id="accordionExample2">
                  <div class="accordion-item">
                    <h1 class="accordion-header" id="headingOne2">
                      <button
                        class="accordion-button btn btn-sm fw-bold"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne2"
                        aria-expanded="true"
                        aria-controls="collapseOne2"
                        style="
                          background: #ebeef6;
                          font-size: 12px;
                          height: 8px;
                          color: #000000;
                        "
                      >
                        Oficinas participantes
                      </button>
                    </h1>
                    <div
                      id="collapseOne2"
                      class="accordion-collapse collapse show"
                      aria-labelledby="headingOne2"
                      data-bs-parent="#accordionExample2"
                    >
                      <div
                        class="accordion-body"
                        style="font-size: 11px; height: 350px"
                      >
                        <div class="col-md-5">
                          <div class="input-group" style="font-size: 12px">
                            <label class="fw-bold"
                              >Buscar:&nbsp;&nbsp;&nbsp;</label
                            ><input
                              type="text"
                              v-model="buscarOficinaLk"
                              class="form-control-sm form-control col-md-2"
                              placeholder="Código o nombre de oficina"
                              style="font-size: 12px"
                              @keyup.enter="buscarOficinaLike()"
                            />
                          </div>
                        </div>
                        <br />

                        <div
                          class="col-md-9"
                          style="
                            overflow-y: scroll;
                            font-size: 10px;
                            min-height: 150px;
                            max-height: 275px;
                            overflow-y: scroll;
                            border: 1.5px;
                            border-style: ridge;
                          "
                        >
                          <table
                            class="table table-bordered table-striped table-sm tab-head"
                          >
                            <thead class="table-light">
                              <tr class="tab-cabecere">
                                <th>Nro</th>
                                <th>Sucursal</th>
                                <th>Código</th>
                                <th>Nombre</th>
                                <th>Provncia</th>
                                <th>Ciudad</th>
                                <th>Acumulación</th>
                                <th>&nbsp;&nbsp;Canje</th>
                              </tr>
                            </thead>
                            <tr
                              v-for="(ofi, index) in arrayOficinasProcess"
                              :key="index"
                              style="border: 0.5px"
                            >
                              <td>{{ index + 1 }}&nbsp;</td>
                              <td class="text-start">
                                {{ ofi.nombre_sucursal }}
                              </td>
                              <td>{{ ofi._id }}</td>
                              <td class="text-start">
                                {{ ofi.nombre_oficina }}
                              </td>
                              <td class="text-start">
                                {{ ofi.nombre_provincia }}
                              </td>
                              <td class="text-start">
                                &nbsp;&nbsp;{{ ofi.nombre_ciudad }}
                              </td>
                              <td v-if="ofi.Acumulacion">SI</td>
                              <td v-else>NO</td>
                              <td v-if="ofi.Canje">SI</td>
                              <td v-else>NO</td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- fin Grupos de  Beneficios -->
          </div>
        </div>

        <!-- fin contenido del modal -->
        <!--</div>--><!-- fin del modal body -->
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary btn-sm"
            data-bs-dismiss="modal"
            @click.prevent="cerrarPromocionTodoTodo()"
          >
            <i class="fas fa-window-close"></i>&nbsp;Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- fin de modal encabezado-->
</template>

<script>
import axios from "axios";
//import Cuerpo from './components/Cuerpo.vue';
//import Promocion from "./components/Promocion.js";
//import Encabezado from "./components/Encabezado.vue";
import TextReaderP from "../service/TextReaderProducto";
import TextReaderC from "../service/TextReaderCiudad";
import TextReaderO from "../service/TextReaderOficina";
import TextReaderPr from "../service/TextReaderProvincia";
import TextReaderR from "../service/TextReaderRegion";
import TextReaderS from "../service/TextReaderSucursal";

import PromoService from "../service/PromocionDataService";
import FechaService from "../service/FechaService";
import IPServie from "../service/ConectionDataService";
import Token from "../service/TokenValidate";
//import Multiselect from "@vueform/multiselect";
import RolesUser from "@/views/service/RolesUser.js";

import Promo from "@/views/promociones/Promocion.vue";

import { constants } from "fs";
export default {
  name: "App",
  data() {
    return {
      //http_local: "http://localhost:8080",
      //http_remote: "http://192.168.236.242:8080",
      ////para ver promocion configuracion
      /*
      arrayCondicionesProcess_: [],
      arrayCondicionesProcessT_: [],
      arrayBeneficiosProcess_: [],
      arrayBeneficiosProcessT_: [],
      arrayOficinasProcess_: [],
      arrayOficinasProcessT_: [],
      arraySucursalesProcess_: [],
      buscarOficinaLk_: "",
      buscarCondicionesLk_: "",
      buscarBeneficiosLk_: "",
      statusConfig_: 0,
      */
      //para los ver configur
          
      arrayCondicionesProcessT_Prm:[],
      arrayCondicionesProcess_Prm:[],

      arrayBeneficiosProcessT_Prm:[],
      arrayBeneficiosProcess_Prm:[],

      // para los saldos del cliente
      respuestaPromo: [],
      status_select: 0,
      status_select_doc_nombre: "",
      descripcionProductSelect: "",
      descripcionProductSelectBenef: "",
      descripcionCliente: "",
      totalTabla: 0,
      selectCodDes: 0,
      aarray: [],
      arrayCondicionesProcess: [],
      arrayCondicionesProcessT: [],
      arrayAcumulacionesAct: [],
      arrayAcumulacionesActTemp: [],
      buscarSerieDocActLk: "",
      arrayAcumulacionesInact: [],

      arrayBeneficiosProcess: [],
      arrayBeneficiosProcessT: [],
      arrayDocumentosCanje: [],
      arrayDocumentosConsumo: [],
      buscarSerieDocLk: "",
      sumaDocConsumo:0,
      arrayDocumentosCanjeTemp: [],
      arrayDocumentosConsumoTemp: [],
      status_select_doc: 0,
      status_select_act_doc: 0,
      status_select_cond_doc: 0,
      status_select_benef_doc: 0,

      arrayOficinasProcess: [],
      arrayOficinasProcessT: [],
      arraySucursalesProcess: [],
      buscarOficinaLk: "",
      buscarCondicionesLk: "",
      buscarBeneficiosLk: "",
      statusConfig: 0,

      buscarPromoProductoLk: "",
      arrayPromocionesAllT: [],

      nroCanjes: 0,
      nroTCanjes: 0,
      ///temp
      aarray_: [],
      arrayCondicionesProcess_: [],
      arrayCondicionesProcessT_: [],
      arrayBeneficiosProcess_: [],
      arrayBeneficiosProcessT_: [],
      arrayOficinasProcess_: [],
      arrayOficinasProcessT_: [],
      arraySucursalesProcess_: [],
      buscarOficinaLk_: "",
      buscarCondicionesLk_: "",
      buscarBeneficiosLk_: "",
      statusConfig_: 0,

      http_: "",
      modulos: [],
      selectTodo: 0,
      paginasTotal: 0,
      paginaActiva: 1,
      controlPaginas: 0,
      //buscar Like
      listaCodigos: "",
      arraryBuscarLike: [],
      palabraClaveLike: "",
      buscarPalabraLike: "",
      mostrarComboLike: false,
      // modalCabecera
      modalCabecera: 0,
      tituloModal: "MI MODAL",
      nombreCRM: "",
      usuario: "",
      usuarioModifica: "",
      fechaRegistro: "",
      fechaUltimoCambio: "",
      estado_proceso: 0, //0:ver registro/1:para editar
      estado_procesoCabecera: 0,
      pagina: 0,
      codigoPromocionDuplicar: [],
      //buscar_
      buscar: "",
      buscar2: "",
      buscar3: "Estado",
      buscar4: "0",
      criterio: "codigoPromocion",
      criterio2: "nombre",
      criterio3: "estado",
      criterio4: "tipoMF",
      controlBusqueda: 0,
      //
      persona_id: 0,
      nombre: "",
      apellido: "",
      direccion: "",
      telefono: "",
      listar: 3,
      arrayPersona: "",
      pageNumber: 1,
      pageSize: 10,
      //inicio encabezado
      codigoPromocion: "",
      codigoPadre: "",
      nombrePromocion: "",
      observacionesPromocion: "",
      fechaInicio: "",
      fechaInicioSistema: "",
      fechaFin: "",
      fechaFinTemporal: "",
      mecanica: "",
      mecanicaValor: 0,
      mecanicaBonificacion: 0,
      periodoCanje: "0",
      unidadPeriodoCanje: "Meses",
      mesPendienteCanje: "1",
      acumulacionCajas: true,
      tipoAcumulacion: "Acumulable",
      tipoMF: "Medicación Frecuente",
      estadoPromocion: "Pendiente",
      fechaInicioAcumulacion: "00/00/0000 00:00",
      noAplicaFIAC: true,
      existePromocion: 0,
      compararFecha: 0,
      mensaje: "Acumula",
      responsablePromo: "0",
      lineaCSolicitante: "0",
      razones: "",

      generaCobro: "SI",
      arrayGeneraCobro: [],
      asumeCategoria: "NO",
      arrayAsumeCategoria: [],
      casos: 0,
      casos_condiciones: 0,
      casos_parte: 0,
      casos_condicion: 0,
      casos_condicion_btn: 0,
      guardaActualiza: 0, //0 guarda 1 actualiza
      //fin encabezado
      //grupos
      grupoCondiciones: [],
      nombreGrupo: "A",
      codigoGrupo: "",
      operadorGrupo: "OR",
      condiciones: [],
      arrayGrupoCondiciones: [], // para capturar la condicíon al momento de fuardar
      //fin de grupos
      // tipo condiciones
      condiciones_id: 0,
      tipoCondicion: "",
      codigoProducto: "",
      codigoPrdAcu: "",
      //
      acumulaCajas: "SI",
      esAcumulable: "SI",

      acumulaCajasCondicion: true,
      esAcumulableCondicion: true,
      retieneCajasCondicion: "SI",
      cantidadCondicion: 0,
      tipoCondicionOY: "",
      condicionCanje: true,
      condicionAcumulacion: true,

      btnFinalizar: "",
      btnfinalizarR: 0,

      arrayTipoCondiciones: [],
      listarMostrarCondicion: 0,
      cantidadProducto: 0,
      operadorCondiciones: "OR",
      precioProducto: 0,
      regionesCondicion: "",
      provinciasCondicion: "",
      ciudadesCondicion: "",
      oficinas: "",

      //condiciones complejas
      relacionAcumulacionCond: 1,
      cumplimientoCond: "individual",
      relacionAcumulacionBenef: 1,

      // fin tipo condiciones
      arrayCondicionesAceptadas: [],

      //Beneficios
      arrayBeneficios: [],
      tipoBenef: "productos",
      codigoProductoBenef: "",
      descuentoBenef: 0,
      cantidadBenef: "",
      operadorBenef: "OR",
      limiteAplicacion: 0,
      limiteCanje: 0,
      indicePadreBenef: 0,
      arrayCombinacionBenef: [],
      arrayCodNombBenef: [],
      indicePadreBeneficio: 0,
      //Proveedor Laboratorio
      modalProvLabSec: 0,

      //Aplicacion
      codigoaplicacion: "1",

      //sucursal:"",
      sucursal: {
        mode: "tags",
        value: ["Todas"],
        options: [
          { codigo: "002", sucursal: "MEDICITY" },
          { codigo: "003", sucursal: "ECONOMICAS" },
          { codigo: "012", sucursal: "PUNTO VITAL" },
          { codigo: "009", sucursal: "PLAN ADMINISTRACION FARMACIAS" },
        ],

        searchable: true,
        createTag: true,
      },
      check_sucursal: "Todas",

      //condiciones
      //buscador
      pagination: {
        total: 0,
        current_page: 0,
        per_page: 0,
        last_page: 0,
        from: 0,
        to: 0,
      },
      idEditar: 0,

      //arrays
      arrayPromocionesAll: [],
      //arbol de condiciones
      bandera: 0,
      indicePadre: 0,
      indiceHijoEdit: 0,
      idPadre: 0,
      indiceHijo: 0,
      idHijo: 0,
      hijoName: "",
      padreSeleccionado: 0,
      nombreA: "",
      idva: 0,
      arrayItem: [],
      arrayItemDetalle: [],
      arrayItemDetalleAx: [],
      dat: [],
      mensajeCondicion: "",
      arrayItemBenef: [],
      //mensales
      modalMensajes: 0,
      condicion_mensajes: 0,
      condicion_mensajesVer: 0,
      idxMensajePromo: 0, // index del array de mensaje promocion
      mensajePromo: "",
      controlVistaPrevMsj: 0,
      mensajePromoVistaPrev: "",
      mensajePromoVistaPrevTemp: "",
      palabraClave: "",
      tipoMensaje: "Acumulación",
      arrayVariables: [],
      arrayMensajes: [],
      arrayMensajesAll: [],
      arrayMensajesPromocion: [],
      arrayMensajesPromocionTipos: [],
      //cobros
      modalCobros: 0,
      //extension
      modalExtension: 0,
      controlExtension: 0,
      controlExtensionCancel: 0,
      modalCondiciones: 0,

      condicion_cobros: 0,
      arrayCobros: [],
      metodoAplicacion: "Porcentaje",
      listaCobro: "ppp",
      tipoPagador: "Farmaenlace",
      valorCobro: 0,
      porcentajeCobro: 0,
      totalPorCobro: 0,
      proveedor: [],
      lineaComercial: {
        mode: "tags",
        value: ["Todas"],
        options: [],
        searchable: true,
        createTag: true,
      },
      errorPromoLgth: 0,
      errorMostrarMsjPromo: [],
      activarSelect: 0,
      modalVistaPrevia: 0,
      textoCodProd: "", // vista previa productos
      empresa_RUC: "",
      empresa_NC: "",
      /////////////////////////////////
    };
  },
  methods: {
    //---
    pasarPaginas(pag) {
      let me = this;
      console.log("pagina: " + pag);
      if (me.controlPaginas == 0) {
        me.listarPromociones(pag, "buscar", "criterio", 1, "codigoPromocion");
      } else {
        me.paginaActiva = pag;
        me.listarPromocionesLike(2);
      }
    },
    anterior() {
      let me = this;
      me.paginaActiva = 1;
      me.listarPromociones(
        me.paginaActiva,
        "buscar",
        "criterio",
        1,
        "codigoPromocion"
      );
    },
    siguiente() {
      let me = this;
      me.paginaActiva = me.paginasTotal;
      me.listarPromociones(
        me.paginaActiva,
        "buscar",
        "criterio",
        1,
        "codigoPromocion"
      );
    },
    cargaParametros() {
      let me = this;
      me.buscar = "";
      me.buscar2 = "";
      me.buscar3 = "Estado";
      me.buscar4 = "0";

      me.listarPromociones(1, "buscar", "criterio", 1, "codigoPromocion");
    },
    //------------

    verPromocionTodoTodo() {
      let me = this;
      me.modalCabecera = 1;
      me.tituloModal = "Detalle Acumulación";
      me.verPromocionParametrizacion(me.codigoPromocion, 0);
    },
    cerrarPromocionTodoTodo() {
      let me = this;
      me.modalCabecera = 0;
    },
    verPromocionParametrizacion(valor, conVerEdit) {
      let me = this;
      console.log("Ver promocion" + valor);
      //me.nuevaPromocion();
      //me.listar = 3;
      //me.estado_proceso = conVerEdit;
      me.arraySucursalesProcess = [];
      //var url = me.http_ + "/acumulacion/mf/promociones/searchOne/" + valor;
      //var url = "http://192.168.236.242:9003/processDocs?getPromoInfo=" + valor;
      var url = IPServie.getURLAPIEXT() + "/processDocs?getPromoInfo=" + valor;
      console.log(url);

      /**
       * ,
      {
        headers:{
          Accept: 'application/json',
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin":'*',
          "Access-Control-Allow-Methods": "GET, POST",
        }
      }
       */

      axios
        .get(
          url
          /*
       {
        headers:{
          'Accept': 'application/json;charset=UTF-8',
          'Content-Type': 'application/json;charset=UTF-8',
          "Access-Control-Allow-Origin":'*',
          "Access-Control-Allow-Methods": "GET, POST",
        },data:{}
      }
      */
        )
        .then(function (response) {
          console.log(response);
          var respuesta = response.data;
          me.codigoPromocion = respuesta.codigoPromocion;
          me.nombrePromocion = respuesta.nombre;
          me.observacionesPromocion = respuesta.observaciones;
          me.nombreCRM = respuesta.nombreCRM;
          me.mecanica = respuesta.mecanica;
          me.periodoCanje = respuesta.periodoCanje;
          //me.unidadPeriodoCanje = respuesta.unidadPeriodoCanje;
          me.mesPendienteCanje = respuesta.mesPendienteCanje;
          me.acumulacionCajas = respuesta.acumulacionCajas;
          me.tipoAcumulacion = respuesta.tipoAcumulacion;
          me.tipoMF = respuesta.tipoMF;
          me.estadoPromocion = respuesta.estado;
          me.responsablePromo = respuesta.responsable;
          me.lineaCSolicitante = respuesta.lineaCSolicitante;
          me.generaCobro = respuesta.generaCobro;
          me.asumeCategoria = respuesta.asumeCategoria;
          me.fechaInicioAcumulacion = respuesta.fechaInicioAcumulacion;
          //me.existePromocion = respuesta.nombre;
          //me.mensaje = respuesta.nombre;
          me.arrayItem = respuesta.grupoCondiciones;
          me.arrayItemBenef = respuesta.beneficio;
          //me.mecanicaValor = respuesta.mecanicaValor;
          //me.mecanicaBonificacion = respuesta.mecanicaBonificacion;

          me.fechaInicio = respuesta.fechaInicio;
          me.fechaFin = respuesta.fechaFin;
          //me.fechaInicioAcumulacion = respuesta.fechaInicioAcumulacion;
          //me.fechaInicio = respuesta.fechaInicio.substring(0, 10) +
          //  "T" +respuesta.fechaInicio.substring(11, 16);
          //me.fechaFin = respuesta.fechaFin.substring(0, 10) +
          //  "T" +respuesta.fechaFin.substring(11, 16);
          //me.fechaInicioAcumulacion = respuesta.fechaInicioAcumulacion.substring(0, 10) +
          //  "T" +respuesta.fechaInicioAcumulacion.substring(11, 16);;

          //me.fecha =arrayVentaT[0]["fecha_hora"].substring(0, 10)+"T" + arrayVentaT[0]["fecha_hora"].substring(11, 16);

          //me.mensajePromo = respuesta.mensajePromo;
          me.arrayMensajesPromocion = respuesta.mensajes;

          //me.cantidadCondicion = me.mecanicaValor;
          //me.cantidadBenef = me.mecanicaBonificacion;
          (me.usuario = respuesta.usuario),
            (me.usuarioModifica = respuesta.usuarioModifica);
          me.fechaRegistro = respuesta.fechaRegistro;
          me.fechaUltimoCambio = respuesta.fechaUltimoCambio;

          me.arrayMensajesPromocionTipos =
            me.arrayMensajesPromocion[0].tipoMensaje;
          //
          if (me.estado_proceso === 1 && me.estadoPromocion === "Activo") {
            me.estado_procesoCabecera = 1;
            me.estado_proceso = -1;
          } else {
            me.estado_procesoCabecera = 0;
          }
          //me.activarEditar();
          //para listar condiciones-beneficios
          //me.arrayBeneficiosProcessT = respuesta.pvBenedicios.grupoBeneficios;
          //me.arrayBeneficiosProcess = respuesta.pvBenedicios.grupoBeneficios;
          //me.arrayCondicionesProcess = respuesta.jvarCondiciones;
          //me.arrayCondicionesProcessT = respuesta.jvarCondiciones;

          me.arrayCondicionesProcess_Prm = respuesta.jvarCondicionesPro;
          me.arrayCondicionesProcessT_Prm = respuesta.jvarCondicionesPro;

          me.arrayBeneficiosProcessT_Prm = respuesta.pvBenedicios.grupoBeneficios;
          me.arrayBeneficiosProcess_Prm = respuesta.pvBenedicios.grupoBeneficios;

          //console.log(me.arrayCondicionesProcessT);
          me.arrayOficinasProcessT = respuesta.oficinas;
          me.arrayOficinasProcess = me.arrayOficinasProcessT;
          me.procesarSucursales();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    procesarSucursales() {
      let me = this;
      let arrayTempO = [];
      let arrayFilter = [];
      let oficinaTx = "";
      let totalS = 0;
      let idSucursal = "";
      let sucursales = ["002", "003", "004", "009", "010", "012", "014", "015"];
      for (let j = 0; j < sucursales.length; j++) {
        totalS = 0;
        for (let i = 0; i < me.arrayOficinasProcess.length; i++) {
          //oficinaTx = me.arrayOficinasProcess[i].nombre_oficina;
          idSucursal = me.arrayOficinasProcess[i].sucursal;
          //console.log(oficinaTx.indexOf(me.buscarOficinaLk)+" --> "+ i+". "+oficinaTx);
          //console.log(sucursales[j]+".."+idSucursal);
          if (sucursales[j] == idSucursal) {
            oficinaTx = me.arrayOficinasProcess[i].nombre_sucursal;
            totalS++;
            //console.log(totalS);
          }
        }
        me.arraySucursalesProcess.push({
          Codigo: sucursales[j],
          Sucursal: oficinaTx,
          Oficinas: totalS,
        });
      }
      console.log(me.arraySucursalesProcess);
    },
    buscarBeneficiosLike() {
      let me = this;
      let arrayTempC = [];
      let arrayFilter = [];
      let arrayOpciones = [];
      let textoTx = "";
      arrayTempC = me.arrayBeneficiosProcessT_Prm;
      //console.log(me.buscarCondicionesLk);
      if (me.buscarBeneficiosLk != "") {
        for (let i = 0; i < arrayTempC.length; i++) {
          arrayOpciones = arrayTempC[i].beneficios;
          //console.log(arrayOpciones);
          for (let j = 0; j < arrayOpciones.length; j++) {

           textoTx = arrayOpciones[j].codigoProducto;
            //} if(me.selectCodDesB == 1) {

            let textoTxDes = arrayOpciones[j].detalleProducto;
            //}

            if (
              textoTx.indexOf(me.buscarBeneficiosLk) != -1 ||
              textoTxDes.indexOf(me.buscarBeneficiosLk.toUpperCase()) != -1
            ) {
              //console.log(i+":"+textoTx);
              arrayFilter.push({ beneficios: arrayOpciones });
              j = arrayOpciones.length;
            } else {
              //console.log(i+":"+arrayTempO[i].nombre_oficina);
            }
          }
        }
        console.log(arrayFilter);
        me.arrayBeneficiosProcess_Prm = arrayFilter;
        //console.log(me.arrayCondicionesProcess);
      } else {
        me.arrayBeneficiosProcess_Prm = me.arrayBeneficiosProcessT_Prm;
      }
    },
    buscarCondicionesLike() {
      let me = this;
      let arrayTempC = [];
      let arrayFilter = [];
      let arrayOpciones = [];
      let textoTx = "";
      arrayTempC = me.arrayCondicionesProcessT_Prm;
      //console.log(me.buscarCondicionesLk);
      if (me.buscarCondicionesLk != "") {
        for (let i = 0; i < arrayTempC.length; i++) {
          arrayOpciones = arrayTempC[i].cod;
          //console.log(arrayOpciones);
          for (let j = 0; j < arrayOpciones.length; j++) {
            textoTx = arrayOpciones[j].codigoProducto;
            //} else {
            let textoTxDes = arrayOpciones[j].descripcionProducto;
            //}

            if (
              textoTx.indexOf(me.buscarCondicionesLk) != -1 ||
              textoTxDes.indexOf(me.buscarCondicionesLk.toUpperCase()) != -1
            ) {
              console.log(i + ":" + textoTx);
              arrayFilter.push({ cod: arrayOpciones });
            } else {
              //console.log(i+":"+arrayTempO[i].nombre_oficina);
            }
          }
        }
        console.log(arrayFilter);
        me.arrayCondicionesProcess_Prm = arrayFilter;
        //console.log(me.arrayCondicionesProcess);
      } else {
        me.arrayCondicionesProcess_Prm = me.arrayCondicionesProcessT_Prm;
      }
    },
    buscarOficinaLike() {
      let me = this;
      let arrayTempO = [];
      let arrayFilter = [];
      let oficinaTx = "";
      arrayTempO = me.arrayOficinasProcessT;
      console.log(me.buscarOficinaLk);
      if (me.buscarOficinaLk != "") {
        for (let i = 0; i < arrayTempO.length; i++) {
          oficinaTx = arrayTempO[i]._id;
          //} else {
            let oficinaTxDes = arrayTempO[i].nombre_oficina;
          //}
          //console.log(oficinaTx.indexOf(me.buscarOficinaLk)+" --> "+ i+". "+oficinaTx);
          if ((oficinaTx.indexOf(me.buscarOficinaLk) != -1) || (oficinaTxDes.indexOf(me.buscarOficinaLk.toUpperCase()) != -1)) {
            //console.log(i+":"+oficinaTx);
            arrayFilter.push(arrayTempO[i]);
          } else {
            //console.log(i+":"+arrayTempO[i].nombre_oficina);
          }
        }
        me.arrayOficinasProcess = arrayFilter;
      } else {
        me.arrayOficinasProcess = me.arrayOficinasProcessT;
      }
    },

    verPromocion(valor, conVerEdit) {
      let me = this;
      me.totalTabla = 0;
      me.sumaDocConsumo =0;
      console.log("Ver promocion: " + valor + "--- " + conVerEdit);
      me.arrayDocumentosCanje = [];
      me.arrayDocumentosConsumo = [];
      me.arrayAcumulacionesAct = [];
      me.arrayAcumulacionesInact = [];
      //me.nuevaPromocion();
      //me.listar = 51;
      me.status_select_doc_nombre = "";
      me.status_select = valor;
      //me.estado_proceso = conVerEdit;
      var respuesta;
      //var url = me.http_ + "/acumulacion/mf/promociones/searchOne/" + valor;
      //var url = "http://192.168.236.242:9003/processDocs?getClienteInfo=" + valor;
      //await axios.get(url) .then(function (response) {
      console.log(valor);
      for (let i = 0; i < me.arrayPromocionesAll.length; i++) {
        if (me.arrayPromocionesAll[i].codigoPromocion == valor) {
          respuesta = me.arrayPromocionesAll[i];
          console.log(respuesta);
        }
      }
      //var respuesta = response.data.promociones;
      console.log(respuesta);
      me.codigoPromocion = respuesta.codigoPromocion;
      me.nombrePromocion = respuesta.nombre;
      me.observacionesPromocion = respuesta.observaciones;
      me.nombreCRM = respuesta.nombreCRM;
      me.mecanica = respuesta.mecanica;
      me.periodoCanje = respuesta.periodoCanje;
      //me.unidadPeriodoCanje = respuesta.unidadPeriodoCanje;
      me.mesPendienteCanje = respuesta.mesPendienteCanje;
      me.acumulacionCajas = respuesta.acumulacionCajas;
      me.tipoAcumulacion = respuesta.tipoAcumulacion;
      me.tipoMF = respuesta.tipoMF;
      me.estadoPromocion = respuesta.estado;
      me.responsablePromo = respuesta.responsable;
      me.lineaCSolicitante = respuesta.lineaCSolicitante;
      me.generaCobro = respuesta.generaCobro;
      me.asumeCategoria = respuesta.asumeCategoria;
      me.fechaInicioAcumulacion = respuesta.fechaInicioAcumulacion;
      //me.existePromocion = respuesta.nombre;
      //me.mensaje = respuesta.nombre;
      //me.arrayItem = respuesta.grupoCondiciones;
      //me.arrayItemBenef = respuesta.beneficio;
      //me.mecanicaValor = respuesta.mecanicaValor;
      //me.mecanicaBonificacion = respuesta.mecanicaBonificacion;
      me.nroCanjes = respuesta.nroCanjes;
      me.nroTCanjes = respuesta.nroTCanjes;

      me.fechaInicio = respuesta.fechaInicio;
      me.fechaFin = respuesta.fechaFin;

      me.arrayBeneficiosProcessT = respuesta.jvarBeneficios;
      me.arrayBeneficiosProcess = respuesta.jvarBeneficios;
      //console.log(me.arrayBeneficiosProcess);

      me.arrayCondicionesProcessT = respuesta.jvarCondicionesPro;
      me.arrayCondicionesProcess = respuesta.jvarCondicionesPro;
      me.procesarSaldosCliente();
      //me.verPromocionTodo(me.codigoPromocion,1);
      me.cargarAcumulacionesAcIn(0, "", "");
      me.cargarCanjesBenef(0, "");
    },

    procesarSaldosCliente() {
      let me = this;
      let arrayTempC = [];
      let arrayFilter = [];
      let arrayOpciones = [];
      let textoTx = "";
      arrayTempC = me.arrayCondicionesProcessT;
      for (let i = 0; i < arrayTempC.length; i++) {
        arrayOpciones = arrayTempC[i].cod;
        arrayFilter.push({ cod: arrayOpciones });
      }
      //console.log(arrayFilter);
      me.arrayCondicionesProcess = arrayFilter;
      //Beneficios
    },
    cargarAcumulacionesAcIn(valor, codProd, prod) {
      let me = this;
      me.totalTabla = 0;
      let arrayTempC = [];
      let arrayFilter = [];
      let arrayOpciones = [];
      let arrayOpcionesAc = [];
      let arrayOpcionesAcInac = [];
      me.descripcionProductSelect = prod;
      console.log("valor: " + valor);
      me.buscarSerieDocActLk="";
      me.status_select_cond_doc = codProd;
      arrayTempC = me.arrayCondicionesProcessT;
      for (let i = 0; i < arrayTempC.length; i++) {
        arrayOpciones = arrayTempC[i].cod;
        arrayFilter.push({ cod: arrayOpciones });
      }
      console.log(arrayFilter);
      //me.arrayCondicionesProcess = arrayFilter;
      if (prod == "") {
        me.descripcionProductSelect = arrayFilter[0].cod[0].descripcionProducto;
        console.log(me.descripcionProductSelect);
      }

      for (let i = 0; i < arrayFilter.length; i++) {
        if (valor == i) {
          arrayOpcionesAc = arrayFilter[i].cod[0].acumulacionesActivas;
          arrayOpcionesAcInac = arrayFilter[i].cod[0].acumulacionesCaducadas;
        }
      }
      /*
      arrayOpcionesAc.sort((x, y)=>
      {
          if (x.FECHA_DOCUMENTO < y.FECHA_DOCUMENTO) {return -1;}
          if (x.FECHA_DOCUMENTO > y.FECHA_DOCUMENTO) {return 1;}
          return 0;
      });
      */

      me.arrayAcumulacionesAct = me.ordenarAcumulaciones(arrayOpcionesAc);
      me.arrayAcumulacionesActTemp = arrayOpcionesAc;
      me.arrayAcumulacionesInact = me.ordenarAcumulaciones(arrayOpcionesAcInac);

      
      //console.log(me.arrayAcumulacionesAct);
    },
    
    cargarCanjesBenef(valor, vall) {
      let me = this;
      let arrayTempB = [];
      let arrayFilterB = [];
      let arrayOpcionesB = [];
      me.status_select_doc = "";
      me.arrayDocumentosConsumo = [];
      me.status_select_doc_nombre = "";
      me.buscarSerieDocLk = "";
      console.log(valor);
      arrayTempB = me.arrayBeneficiosProcessT;
      me.status_select_benef_doc = vall;
      console.log(arrayTempB);
      for (let i = 0; i < arrayTempB.length; i++) {
        if (valor == i) {
          me.arrayDocumentosCanje = arrayTempB[i].beneficios[0].documentosCanje;
          me.arrayDocumentosCanjeTemp =
            arrayTempB[i].beneficios[0].documentosCanje;
          //me.arrayDocumentosConsumo =arrayTempB[i].beneficios[0].documentosConsumo;
          me.arrayDocumentosConsumoTemp =
            arrayTempB[i].beneficios[0].documentosConsumo;
          me.descripcionProductSelectBenef =
            arrayTempB[i].beneficios[0].detalleProducto;
        }
      }
      //console.log(me.arrayDocumentosCanje);
      //console.log(me.arrayDocumentosConsumo);
      me.arrayDocumentosCanje=me.ordenarAcumulaciones(me.arrayDocumentosCanje);
    },
    //orden las acumulaciones, canjes y consumos por fecha
    ordenarAcumulaciones(arrayAcum){
      arrayAcum.sort((x, y)=>
      {
          if (x.FECHA_DOCUMENTO < y.FECHA_DOCUMENTO) {return -1;}
          if (x.FECHA_DOCUMENTO > y.FECHA_DOCUMENTO) {return 1;}
          return 0;
      });
      return arrayAcum;
    },
    limpiarSaldosCliente() {
      let me = this;
      me.arrayDocumentosCanje = [];
      me.arrayDocumentosConsumo = [];
      me.aarray = [];
      me.arrayCondicionesProcess = [];
      me.arrayCondicionesProcessT = [];
      me.arrayAcumulacionesAct = [];
      me.arrayAcumulacionesInact = [];

      me.arrayBeneficiosProcess = [];
      me.arrayBeneficiosProcessT = [];

      me.codigoPromocion = "";
      me.nroCanjes = "";
      me.nroTCanjes = "";
      me.observacionesPromocion = "";
      me.mecanica = "";
      me.tipoMF = "";
      me.fechaInicioAcumulacion = "";
      me.periodoCanje = "";
      me.mesPendienteCanje = "";
      me.descripcionProductSelect = "";
    },

    nuevaPromocion() {
      let me = this;
      me.listar = 3;

      me.codigoPromocion = "";
      me.nombrePromocion = "";
      me.observacionesPromocion = "";
      me.nombreCRM = "";
      me.fechaInicio = FechaService.fechaHoy();
      me.fechaInicio = me.fechaInicio.substring(0, 10) + "T00:00"; //+me.fechaInicio.substring(11,16);
      me.fechaInicioSistema = FechaService.fechaHoy();
      me.fechaInicioSistema = me.fechaInicioSistema.substring(0, 10) + "T00:00"; //+me.fechaInicioSistema.substring(11,16);
      me.fechaFin = me.fechaInicioSistema.substring(0, 10) + "T23:59";
      me.mecanica = "";
      me.periodoCanje = "0";
      me.mesPendienteCanje = "1";
      me.tipoAcumulacion = "Acumulable";
      me.tipoMF = "Medicación Frecuente";
      me.estadoPromocion = "Pendiente";
      me.acumulacionCajas = true;
      me.grupoCondiciones = [];
      me.arrayBeneficios = [];
      me.mensaje = "";
      me.arrayCondicionesAceptadas = [];
      me.nombreGrupo = "A";
      me.codigoGrupo = "";
      me.operadorGrupo = "OR";
      me.arrayItem = [];
      me.arrayItemBenef = [];
      me.mecanicaValor = 0;
      me.mecanicaBonificacion = 0;
      me.fechaInicioAcumulacion = "01/01/2021 00:00";
      me.btnfinalizarR = 0;
      me.compararFecha = 0;
      me.responsablePromo = "0";
      me.generaCobro = "SI";
      me.asumeCategoria = "NO";
      me.lineaCSolicitante = "0";

      me.arrayMensajesPromocion = [];
      me.arrayMensajesPromocionTipos = [];
      //me.estado_proceso=0;
    },

    listarPromociones(pagina_, buscar_, criterio_, ascdesc, descOrdenacion) {
      let me = this;
      me.arrayPromocionesAll = [];
      //pagina_ = 1;
      if (buscar_ == "") {
        buscar_ = "buscar";
      }
      if (criterio_ == "") {
        criterio_ = "criterio";
      }
      //console.log("Buscar:"+buscar_+"Cirterio: "+criterio_);
      console.log("Lista de promociones:" + ascdesc);

      var url =
        me.http_ +
        "/acumulacion/mf/promociones/searchAll/" +
        pagina_ +
        "/" +
        buscar_ +
        "/" +
        criterio_ +
        "/" +
        ascdesc +
        "/" +
        descOrdenacion;
      //var url = me.http_ + "/acumulacion/mf/promociones/all";

      //console.log(me.getHeaders());
      axios
        .get(url)
        .then(function (response) {
          console.log(response);
          //var respuesta = response.data;
          me.arrayPromocionesAll = response.data.data;
          me.paginasTotal = response.data.total;
          //console.log(me.arrayPromocionesAll);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    listarPromocionesCliente(cliente) {
      let me = this;
      me.arrayPromocionesAll = [];
      me.limpiarSaldosCliente();
      //me.arrayPromocionesAll = me.datosCliente.promociones;
      //console.log(me.arrayPromocionesAll);

      //var url ="http://192.168.236.242:9003/processDocs?getClienteInfo=" + cliente;
      var url =
        IPServie.getURLAPIEXT() + "/processDocs?getClienteInfo=" + cliente;
      console.log(url);

      axios
        .get(url)
        .then(function (response) {
          console.log(response);
          //var respuesta = response.data;
          me.arrayPromocionesAll = response.data.promociones;
          me.arrayPromocionesAllT = response.data.promociones;
          me.descripcionCliente = response.data.descripcionCliente;

          //me.paginasTotal = response.data.total;
          //console.log(me.arrayPromocionesAll);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    buscarPromoProducto() {
      let me = this;
      let arrayPromo = [];
      let arrayPromoCod = [];
      let arrayFilter = [];
      let textoLk = "";
      arrayPromo = me.arrayPromocionesAllT;
      if (me.buscarPromoProductoLk != "") {
        for (let i = 0; i < arrayPromo.length; i++) {
          arrayPromoCod = arrayPromo[i].productosVar;
          for (let j = 0; j < arrayPromoCod.length; j++) {
            //if (me.selectCodDes == 0) {
              textoLk = arrayPromoCod[j].codigoProducto;
            //} else {
              let textoLkNomb = arrayPromoCod[j].nombreProducto;
            //}
            if ((textoLk.indexOf(me.buscarPromoProductoLk) != -1)||(textoLkNomb.indexOf(me.buscarPromoProductoLk.toUpperCase()) != -1)) {
              arrayFilter.push(arrayPromo[i]);
            }
          }
          //console.log(arrayFilter);
        }
        me.arrayPromocionesAll = arrayFilter;
      } else {
        me.arrayPromocionesAll = me.arrayPromocionesAllT;
      }
    },
    listarPromocionesLike(val) {
      let me = this;

      me.controlPaginas = 1;
      var url = "";
      var buscar2_ = "",
        buscar3_ = "",
        buscar4_ = "";
      var criterio2_ = "",
        criterio3_ = "",
        criterio4_ = "";
      let controlCodigo = 0;
      me.controlBusqueda = 0;
      me.arrayPromocionesAll = [];
      if (val == 1) {
        me.paginaActiva = 1;
      }
      if (val == 3) {
        me.buscar2 = "";
        me.buscar3 = "Estado";
        me.buscar4 = "0";
        me.controlBusqueda = 0;
      }
      if (me.buscar != "") {
        controlCodigo = 1;
      }
      if (me.buscar2 == "" && me.buscar3 == "" && me.buscar4 == "0") {
        //000
        me.controlBusqueda = 0;
      }
      if (me.buscar2 != "" && me.buscar3 != "" && me.buscar4 == "0") {
        //110
        me.controlBusqueda = 1;
        buscar2_ = me.buscar2.toUpperCase();
        criterio2_ = me.criterio2;
        buscar3_ = me.buscar3;
        criterio3_ = me.criterio3;
      }
      if (me.buscar2 != "" && me.buscar3 == "Estado" && me.buscar4 != "0") {
        //101
        me.controlBusqueda = 2;
        buscar2_ = me.buscar2.toUpperCase();
        criterio2_ = me.criterio2;
        buscar3_ = me.buscar4;
        criterio3_ = me.criterio4;
      }
      if (me.buscar2 != "" && me.buscar3 == "Estado" && me.buscar4 == "0") {
        //100
        me.controlBusqueda = 3;
        buscar2_ = me.buscar2.toUpperCase();
        criterio2_ = me.criterio2;
      }
      if (me.buscar2 == "" && me.buscar3 != "Estado" && me.buscar4 != "0") {
        //011
        me.controlBusqueda = 4;
        buscar2_ = me.buscar3;
        criterio2_ = me.criterio3;
        buscar3_ = me.buscar4;
        criterio3_ = me.criterio4;
      }
      if (me.buscar2 == "" && me.buscar3 != "Estado" && me.buscar4 == "0") {
        //010
        me.controlBusqueda = 5;
        buscar2_ = me.buscar3;
        criterio2_ = me.criterio3;
      }
      if (me.buscar2 == "" && me.buscar3 == "Estado" && me.buscar4 != "0") {
        //001
        me.controlBusqueda = 6;
        buscar2_ = me.buscar4;
        criterio2_ = me.criterio4;
      }
      if (me.buscar2 != "" && me.buscar3 != "Estado" && me.buscar4 != "0") {
        //111
        me.controlBusqueda = 7;
        buscar2_ = me.buscar2.toUpperCase();
        criterio2_ = me.criterio2;
        buscar3_ = me.buscar3;
        criterio3_ = me.criterio3;
        buscar4_ = me.buscar4;
        criterio4_ = me.criterio4;
      }

      ////////console.log("Buscar:"+buscar_+"Cirterio: "+criterio_);
      console.log("Lista de promociones");
      if (me.controlBusqueda == 0 && controlCodigo == 0) {
        console.log("Ingr1");
        url =
          me.http_ +
          "/acumulacion/mf/promociones/searchAll/" +
          me.paginaActiva +
          "/buscar/criterio/1/codigoPromocion";
      }
      if (me.controlBusqueda == 0 && controlCodigo == 1) {
        console.log("Ingr2");
        url =
          me.http_ + "/acumulacion/mf/promociones/searchOneList/" + me.buscar;
      }
      if (
        me.controlBusqueda == 1 ||
        me.controlBusqueda == 2 ||
        me.controlBusqueda == 4
      ) {
        console.log("Ingr3");
        url =
          me.http_ +
          "/acumulacion/mf/promociones/searchAllDos/" +
          me.paginaActiva +
          "/" +
          buscar2_ +
          "/" +
          criterio2_ +
          "/" +
          buscar3_ +
          "/" +
          criterio3_;
      }
      if (
        me.controlBusqueda == 3 ||
        me.controlBusqueda == 5 ||
        me.controlBusqueda == 6
      ) {
        console.log("Ingr4:" + me.controlBusqueda);
        url =
          me.http_ +
          "/acumulacion/mf/promociones/searchAll/" +
          me.paginaActiva +
          "/" +
          buscar2_ +
          "/" +
          criterio2_ +
          "/1/codigoPromocion";
      }
      if (me.controlBusqueda == 7) {
        console.log("Ingr5");
        url =
          me.http_ +
          "/acumulacion/mf/promociones/searchAllTres/" +
          me.paginaActiva +
          "/" +
          buscar2_ +
          "/" +
          criterio2_ +
          "/" +
          buscar3_ +
          "/" +
          criterio3_ +
          "/" +
          buscar4_ +
          "/" +
          criterio4_;
      }
      console.log(url);
      //var url = me.http_ + "/acumulacion/mf/promociones/all";
      axios
        .get(url)
        .then(function (response) {
          console.log(response);
          //var respuesta = response.data;
          me.arrayPromocionesAll = response.data.data;
          me.paginasTotal = response.data.total;
          //console.log(me.arrayPromocionesAll);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    buscarSerieDocumento() {
      let me = this;
      let arrayDocs = [];
      let arrayFilter = [];
      let textoLk = "";
      me.arrayDocumentosConsumo = [];
      me.status_select_doc_nombre = "";
      arrayDocs = me.arrayDocumentosCanjeTemp;
      if (me.buscarSerieDocLk != "") {
        for (let i = 0; i < arrayDocs.length; i++) {
          //console.log(arrayDocs[i]);
          textoLk = arrayDocs[i].SERIE_DOCUMENTO;
          if (textoLk.indexOf(me.buscarSerieDocLk) != -1) {
            arrayFilter.push(arrayDocs[i]);
            //console.log(me.buscarSerieDocLk)
          }
        }
        //console.log(arrayFilter)
        me.arrayDocumentosCanje = arrayFilter;
      } else {
        me.status_select_doc = 0;
        me.arrayDocumentosCanje = me.arrayDocumentosCanjeTemp;
        me.arrayDocumentosConsumo = [];
        me.status_select_doc_nombre = "";
        //me.arrayDocumentosConsumo =me.arrayDocumentosConsumoTemp;
      }
    },
    buscarSerieDocumentoActivo() {
      let me = this;
      let arrayDocs = [];
      let arrayFilter = [];
      let textoLk = "";
      arrayDocs = me.arrayAcumulacionesActTemp;
      if (me.buscarSerieDocActLk != "") {
        for (let i = 0; i < arrayDocs.length; i++) {
          //console.log(arrayDocs[i]);
          textoLk = arrayDocs[i].SERIE_DOCUMENTO;
          if (textoLk.indexOf(me.buscarSerieDocActLk) != -1) {
            arrayFilter.push(arrayDocs[i]);
            //console.log(me.buscarSerieDocLk)
          }
        }
        //console.log(arrayFilter)
        me.arrayAcumulacionesAct = arrayFilter;
      } else {
        me.status_select_act_doc = 0;
        me.arrayAcumulacionesAct = me.arrayAcumulacionesActTemp;
        //me.arrayDocumentosConsumo =me.arrayDocumentosConsumoTemp;
      }
    },
    //cargarAcumuActSelect() {},
    cargarDocConsumoSelect(valor) {
      let me = this;
      me.status_select_doc = valor;
      me.status_select_doc_nombre = valor;
      let arrayDocs = [];
      let arrayFilter = [];
      let textoLk = "";
      me.sumaDocConsumo=0;
      arrayDocs = me.arrayDocumentosConsumoTemp;
      console.log(valor);
      console.log(arrayDocs);
      for (let i = 0; i < arrayDocs.length; i++) {
        if (valor == arrayDocs[i].DOCUMENTO_CANJE) {
          arrayFilter.push(arrayDocs[i]);
          console.log(me.buscarSerieDocLk);
        }
      }
      console.log(arrayFilter);
      me.arrayDocumentosConsumo = arrayFilter;
      
      for(let j=0; j < me.arrayDocumentosConsumo.length; j++){
        me.sumaDocConsumo = me.sumaDocConsumo + me.arrayDocumentosConsumo[j].CANTIDAD_PUNTOS;
      }
      
    },

    async validarToken() {
      //let me = this;
      let loginResponse = await Token.validarToken(
        localStorage.getItem("token")
      );
      console.log(loginResponse);
      if (loginResponse.data == false) {
        localStorage.removeItem("fechaA");
        localStorage.removeItem("user");
        location.reload();
        return;
      }
    },
  },
  computed: {
    //Calcular total porcentaje cobro
    calcularTPCobro: function () {
      let me = this;
      var resultado = 0.0;
      console.log(me.arrayCobros.length);
      for (var i = 0; i < me.arrayCobros.length; i++) {
        resultado = resultado + me.arrayCobros[i].valor;
      }
      return resultado;
    },
  },
  async mounted() {
    let me = this;
    /*
    me.validarToken();
    me.modulos = await RolesUser.getRole(localStorage.getItem("user"));
    if(RolesUser.getPermisoPagina(me.modulos,"promociones_mf","visualizar")==0){
        return;
    }
    let date = new Date();
    let fechaSesionH =
      String(date.getDate()).padStart(2, "0") +
      "/" +
      String(date.getMonth() + 1).padStart(2, "0") +
      "/" +
      date.getFullYear();
    let fechaSesion = localStorage.getItem("fechaA");
    if (fechaSesion == null) {
      localStorage.removeItem("user");
      location.reload();
      return;
    }
    if (fechaSesionH.valueOf() > fechaSesion.valueOf()) {
      localStorage.removeItem("fechaA");
      localStorage.removeItem("user");
      location.reload();
      return;
    }
    me.usuario = localStorage.getItem("user");
    me.usuarioModifica = localStorage.getItem("user");

*/
    console.log("usuario: " + me.usuario);
    console.log("usuarioMod: " + me.usuario);
    me.listar = 51;
    //me.http_ = me.http_local;
    //me.http_ = me.http_remote;
    me.http_ = IPServie.getURL();
    console.log(me.http_);
    me.controlPaginas = 0;
    //me.cargaParametros();
  },
  components: {
    //Encabezado,
    //Multiselect,
    //Producto,
    //Mensaje,

    TextReaderP,
    TextReaderC,
    TextReaderO,
    TextReaderPr,
    TextReaderR,
    TextReaderS,
    Promo,
  },
};
</script>
<!-- <style src="@vueform/multiselect/themes/default.css"></style> -->

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000000;
  margin-top: 10px;
  width: 100%;
}
.row {
  margin: 4px 0;
}
.card-body {
  font-size: 13px;
}
.mostrar {
  display: list-item !important;
  opacity: 1 !important;
  /*position: absolute !important; */
  background-color: #3c29297a !important;
}
.list-group-item:active {
  opacity: 0.5;
  cursor: pointer;
  background: #ecf0f1;
}
</style>

<style>
.switch {
  position: relative;
  display: inline-block;
  width: 90px;
  height: 13px;
}

.switch input {
  opacity: 0;
  width: 100;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /*
    background-color: #2196f3;
    */
  background-color: #139ab8;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 11px;
  width: 11px;
  left: 1px;
  bottom: 1px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #139ab8;
}

input:focus + .slider {
  box-shadow: 0 0 1px #5cad8a;
}

input:checked + .slider:before {
  -webkit-transform: translateX(36px);
  -ms-transform: translateX(6px);
  transform: translateX(77px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 0px;
}

.slider.round:before {
  border-radius: 0%;
}
</style>
<style>
.tab-cabecere {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: #eeeeee;
}
.tab-head {
  font-size: 10px;
  border: 0.5px;
  background: #fdf8e4;
}
</style>
